import CryptoJS from 'crypto-js';
import { React, useEffect, useRef, useState } from "react";
import bg_image from "../../../Assets/img/Personal_bg_image.png";
import { useUserDetailContext } from "../../UserDetailContext";
// import EditIcon from '@mui/icons-material/Edit';
import { EmailRounded } from '@material-ui/icons';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupsIcon from '@mui/icons-material/Groups';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Autocomplete, Avatar, Badge, Box, Button, Checkbox, Chip, Collapse, Divider, FormControl, Grid, IconButton, InputAdornment, MenuItem, Modal, Paper, styled, Tab, Tabs, TextField, Tooltip, useMediaQuery } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import axios from "axios";
import { buildStyles, CircularProgressbarWithChildren, } from "react-circular-progressbar";
import { FaFileAlt, FaFileImage } from 'react-icons/fa';
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import defaultprofile from '../../../Assets/img/Default-Profile.jpg';
import VerifySuccess from '../../../Assets/img/Email-Verified.png';
import { ReactComponent as CalendarIcon } from "../../../Assets/img/icons/calendar-icon-figma.svg";
import { ReactComponent as DocxThumb } from '../../../Assets/img/icons/docx-thumbnail.svg';
import { ReactComponent as EditIcon } from '../../../Assets/img/icons/edit-icon-figma.svg';
import { ReactComponent as ExcelThumb } from '../../../Assets/img/icons/excel-thumbnail.svg';
import { ReactComponent as GenderIcon } from "../../../Assets/img/icons/gender-neutral.svg";
import { ReactComponent as InviteIcon } from '../../../Assets/img/icons/invite-figma.svg';
import { ReactComponent as PdfThumb } from '../../../Assets/img/icons/pdf-thumbnail.svg';
import { ReactComponent as PptxThumb } from '../../../Assets/img/icons/pptx-thumbnail.svg';
import { ReactComponent as ShareIcon } from '../../../Assets/img/icons/share-icon-figma.svg';
import { ReactComponent as SmallUserIcon } from "../../../Assets/img/icons/user-icon-figma.svg";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import { ReactComponent as ViewOptionsIcon } from "../../../Assets/img/icons/view-options-figma.svg";
import { useProfileContext } from '../../ProfileDetailContext';
import FileDragUpload from '../../Utilities/FileUploadAttachDocs';
import { hobbiesSections } from '../../Utilities/HobbiesContext';
import useApi from '../../Utilities/useAPI';
import QrCodeProfile from "./QrCodeProfile";
// import { ReactComponent as MaleIcon } from "../../../Assets/img/icons/gender-male.svg";
// import { ReactComponent as FemaleIcon } from "../../../Assets/img/icons/gender-female.svg";
import isEqual from 'lodash/isEqual';
import { matchIsValidTel, MuiTelInput } from 'mui-tel-input';
import { ReactComponent as AiLogo } from "../../../Assets/img/icons/ai-rewrite-logo.svg";
import { ReactComponent as MarriedIcon } from "../../../Assets/img/icons/married-icon-figma.svg";
import { ReactComponent as AddressIcon } from "../../../Assets/img/icons/resume-location-icon.svg";
import { ReactComponent as SingleFemaleIcon } from "../../../Assets/img/icons/single-female-figma.svg";
import { ReactComponent as SingleMaleIcon } from "../../../Assets/img/icons/single-male-figma.svg";

import {
    ACCEPT_IMAGE,
    ACCEPT_PDF,
    FAMILY,
    HEALTH,
    HOBBIES,
    LANGUAGE
} from "../../../config/constant";
import { deletePersonalProfileFamilyReducer, getPersonalHealthDocumentsReducer, getPersonalInfoReducer, getPersonalProfileFamilyReducer, getPersonalProfileHealthReducer, getPersonalProfileHobbiesReducer, getPersonalProfileLanguagesReducer, getProfileCompletionReducer, postHealthBlobReducer, postPersonalCoverImageReducer, postPersonalProfileFamilyReducer, postPersonalProfileGenerateAboutMeReducer, postPersonalProfileHealthReducer, postPersonalProfileHobbiesReducer, postPersonalProfileImageReducer, postPersonalProfileLanguagesReducer, postPersonalProfileReducer, postPersonalProfileUpdateVisibilityReducer } from "../../../Redux/Reducers/ProfileReducer";
import { PhoneInputMenuProps } from "../../Onboarding/ActiveStep4";
import { useQuantityContext } from "../../QuantityContext";
import { CircleCropper, RectangleCropper } from "../../Utilities/Croppers";
import { AlertDialog } from "./ProfessionalProfile";
import { InviteProfile, ShareProfile, ViewConnections } from "./ProfileConnectionComponents";

import { useDispatch, useSelector } from "react-redux";

export const CustomChip = styled(Chip)(({ theme }) => ({
    '& .MuiChip-deleteIcon': {
        color: '#EB4E3D',
        '&:hover': {
            color: '#EB4E3DD5',
        },
    },
}));

export const customHealthPaper = styled(Paper)(({ theme }) => ({
    maxWidth: 'calc(50% - 16px)',  // Width of the dropdown
    overflowY: 'auto',  // Enable scrolling
}));

const PersonalProfile = ({ settriggeredApi }) => {

    const { PersonalDetails, setPersonalDetails, personalProfileCompletion, getCompletionStatus,
        openDocumentViewer, connectionList, setConnectionList } = useProfileContext();

    const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data)

    const Hobbies = useSelector((state) => {
        const hobbiesInfo = state?.ProfileArray?.personalProfileHobbies?.data?.hobbies_info;
        return hobbiesInfo ? JSON.parse(hobbiesInfo) : []; // Convert string to array
    });

    const Languages = useSelector((state) => {
        const languages = state?.ProfileArray?.personalProfileLanguages?.data?.language_info;
        return languages ? JSON.parse(languages) : [];

    });
    const isLanguagesPublic = useSelector((state) => state?.ProfileArray?.personalProfileLanguages?.data?.is_public)


    const Healthallergies = useSelector((state) => {
        const healthallergies = state?.ProfileArray?.healthData?.data?.allergies;
        return healthallergies ? JSON.parse(healthallergies) : [];
    });

    const Healthmedical_condition = useSelector((state) => {
        const healthmedicalcondition = state?.ProfileArray?.healthData?.data?.medical_condition;
        return healthmedicalcondition ? JSON.parse(healthmedicalcondition) : [];
    });

    const Healthmedical_history = useSelector((state) => {
        const healthmedicalhistory = state?.ProfileArray?.healthData?.data?.medical_history;
        return healthmedicalhistory ? JSON.parse(healthmedicalhistory) : [];
    });



    const HealthBlood = useSelector((state) => {
        const healthBlood = state?.ProfileArray?.healthData?.data?.blood_group;
        return healthBlood;
    })

    const HealthIsPublic = useSelector((state) => {
        const healthispublic = state?.ProfileArray?.healthData?.data?.is_public;
        return healthispublic;
    })

    const HealthDocumentsAttach = useSelector((state) => state?.ProfileArray?.HealthDocuments?.data)
  

    const Familydata = useSelector((state) => state?.ProfileArray?.FamilyData?.data || []);

    const profileCompletionPercentage = useSelector((state) => state?.ProfileArray?.profileCompletion?.data?.personal_profile_completion) || 0;

    // const { hobbies, personalLanguages, connectionCount } = PersonalDetails

    const [isFieldPublic, setIsFieldPublic] = useState({
        firstName: true,
        lastName: true,
        dateOfBirth: true,
        nickName: true,
        personalEmail: true,
        phoneNumber: true,
        gender: true,
        maritalStatus: true,
        personAddress: true,
    });


    const { userDetails } = useUserDetailContext();
    const { openSnackbar } = useQuantityContext();
    const dispatch = useDispatch();
    const { callApiFunction } = useApi();
    const isHobbiesPublic = useSelector((state) => state?.ProfileArray?.personalProfileHobbies?.data?.is_public);
    // console.log("userDetails===", userDetails)
    const [loading, setLoading] = useState(false);
    const { handleInfo } = useQuantityContext();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let objectId = searchParams.get("objectId");
    // console.log("search param objectid", objectId);
    if (!objectId) {
        // If objectId is not found in URL params, try to get it from localStorage
        objectId = localStorage.getItem("objectId");
    } else {
        // If objectId is found in URL params, set it in localStorage
        localStorage.setItem("objectId", objectId);
    }
    const userObjectId = localStorage.getItem('objectId');

    const isSmallLaptop = useMediaQuery('(max-width:1200px)');

    const [activeMenu, setActiveMenu] = useState('my_profile');
    const [dobFlag, setdobFlag] = useState(true)
    const dateOfBirth = "27-08-2024";

    const headers = {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userObjectId}`
    };

    const userFirstName = userDetails.firstName;
    const userLastName = userDetails.lastName;

    // Connection, Share, and Invite
    const [connectionViewModal, setConnectionViewModal] = useState(false);
    const [openShareProfile, setOpenShareProfile] = useState(false);
    const encryptedUrlRef = useRef('');     // Using a ref to persist encryptedUrl across renders without causing re-renders
    const [openInviteProfile, setOpenInviteProfile] = useState(false);
    const qrCodeSize = isSmallLaptop ? 80 : undefined;

    useEffect(() => {
        if (Personaldata?.user_ref_id) {
            const encryptedId = CryptoJS.AES.encrypt(Personaldata?.user_ref_id.toString(), 'UserDetailsSecretKey').toString();
            encryptedUrlRef.current = encodeURIComponent(encryptedId);
        }
    }, [Personaldata]);  // Only re-calculate when userRefId changes

    const [cardDetails, setCardDetails] = useState({
        User_ID: objectId,
        ProfilePicture: {
            name: '',
            type: '',
            data: ''
        },
        CompanyLogo: {
            name: '',
            type: '',
            data: ''
        },
        NickName: '',
        PhoneNumber: '',
        Address: '',
        DOB: '',
        Gender: 'Male',
        Hobbies: '',
        Designation: '',
        Department: '',
        Company: '',
        MaritalStatus: 'Single'
    });

    const updateCardDetails = (updatedDetails) => {
        setCardDetails((prevDetails) => ({
            ...prevDetails,
            ...updatedDetails,
        }));
    };


    const [PersonalEdited, setPersonalEdited] = useState({
        firstName: userDetails?.name.split(' ')[0],
        lastName: userDetails?.name.split(' ')[1],
        dateOfBirth: Personaldata?.dob || userDetails?.dob || null,
        nickName: Personaldata?.nick_name || '',
        personalEmail: userDetails?.email,
        phoneNumber: userDetails?.phone,
        gender: Personaldata?.gender || '',
        maritalStatus: Personaldata?.marital_status || '',
        personAddress: Personaldata?.address || '',
        isDobAvalaible: dobFlag,
        aboutme: Personaldata?.about_me || '',
        coverPic: Personaldata?.user_cover_url,
        profilePic: Personaldata?.user_profile_url
    });
    const [aboutOpen, setAboutOpen] = useState(false);
    const [text, setText] = useState(PersonalEdited?.aboutme);
    const [personalProfileLanguages, setPersonalProfileLanguages] = useState(Languages);

    const [personalHobbies, setPersonalHobbies] = useState(Hobbies);
    const [isEdit, setisEdit] = useState(false);


    const [isSectionPublic, setIsSectionPublic] = useState({
        hobbies: isHobbiesPublic || true,
        aboutme: Personaldata?.is_about_public,
        languages: isLanguagesPublic || true,
        Health: HealthIsPublic || true,
        Family: true,
    })


    const [isHealthEdit, setisHealthEdit] = useState(false);
    const [healthEditState, setHealthEditState] = useState({
        allergy: Healthallergies || [],
        medicCondition: Healthmedical_condition || [],
        blood: HealthBlood || '',
        medicHistory: Healthmedical_history || [],
        // medicAttachments: HealthDocumentsAttach || [],
        medicAttachments: Array.isArray(HealthDocumentsAttach) ? HealthDocumentsAttach : [],
        removedAttachments: []
    })

    const father = Array.isArray(Familydata)
        ? Familydata.find(item => item?.relation_name === "Father") || {}
        : {}
    const mother = Array.isArray(Familydata)
        ? Familydata.find(item => item?.relation_name === "Mother") || {}
        : {}
    const spouse = Array.isArray(Familydata)
        ? Familydata.find(item => item?.relation_name === "Spouse") || {}
        : {}
    const kids = Array.isArray(Familydata)
        ? Familydata.filter(item => item?.relation_name === "Kid") // Use filter() to get all kids
        : [];

    const [personalFamilyDetails, setPersonalFamilyDetails] = useState({
        fatherDet: {
            id: father?.id || null,
            fName: father?.relative_first_name || '',
            lName: father?.relative_last_name || '',
            dob: father?.relative_dob || '',
            blood: father?.relative_blood_group || '',
            email: father?.guardian_email || '',
            phoneNo: father?.guardian_phone_no || '',
            isVerified: father?.is_guardian_verified || false
        },
        motherDet: {
            id: mother?.id || null,
            fName: mother?.relative_first_name || '',
            lName: mother?.relative_last_name || '',
            dob: mother?.relative_dob || '',
            blood: mother?.relative_blood_group || '',
            email: mother?.guardian_email || '',
            phoneNo: mother?.guardian_phone_no || '',
            isVerified: mother?.is_guardian_verified || false
        },
        spouseDet: {
            id: spouse?.id || null,
            fName: spouse?.relative_first_name || '',
            lName: spouse?.relative_last_name || '',
            dob: spouse?.relative_dob || '',
            blood: spouse?.relative_blood_group || '',
            email: spouse?.guardian_email || '',
            phoneNo: spouse?.guardian_phone_no || '',
            isVerified: spouse?.is_guardian_verified || false
        },
        // kids: Array.isArray(kids)
        //     ? kids.map(kid => ({
        //         id: kid?.id || null,
        //         fName: kid?.relative_first_name || '',
        //         lName: kid?.relative_last_name || '',
        //         dob: kid?.relative_dob || '',
        //         blood: kid?.relative_blood_group || ''
        //     }))
        //     : []
        kids: kids.map(kid => ({
            id: kid?.id || null,
            fName: kid?.relative_first_name || '',
            lName: kid?.relative_last_name || '',
            dob: kid?.relative_dob || '',
            blood: kid?.relative_blood_group || ''
        }))
    });



    const removeHealthMedicalAttachment = (index) => {
        setHealthEditState((prevState) => {
            const removed = prevState.medicAttachments[index];
            const updatedAttachments = prevState.medicAttachments.filter((_, i) => i !== index);

            return {
                ...prevState,
                medicAttachments: updatedAttachments,
                removedAttachments: [...prevState.removedAttachments, removed],
            };
        });
    };
    // const handleDOBChange = (event) => {
    //     const dateString = event.target.value;
    //     const dateObject = new Date(dateString);
    //     if (!isNaN(dateObject.getTime())) {
    //         updateCardDetails({ DOB: dateString });

    //     } else {
    //         console.error('Invalid date');
    //     }
    // };


    const navigate = useNavigate();

    const activeTab = searchParams.get("tab") || "my_profile";
    const handleDOBChange = (event) => {
        setPersonalEdited({
            ...PersonalEdited,
            dateOfBirth: event.target.value,
        });
        setdobFlag(false)
    };


    useEffect(() => {
        setActiveMenu(activeTab);
    }, [activeTab]);

    const handleMenuClick = (_, newValue) => {
        // console.log("ACTIVE MENU", newValue);
        setActiveMenu(newValue); // Update local state
        navigate(`/myprofile?tab=${newValue}`); // Update URL with the new tab
    };

    const [bgImage, setBgImage] = useState(PersonalEdited?.coverPic || bg_image);
    const [selectedBgFile, setSelectedBgFile] = useState(null);
    const [selectedBgImage, setSelectedBgImage] = useState(null);
    const bgImageRef = useRef(null);
    const [openRectCropper, setOpenRectCropper] = useState(false);

    const handleRectCropperClose = () => {
        setOpenRectCropper(false);
        setSelectedBgFile(null);
        setSelectedBgImage(null);
    }

    const handleBgImageChange = async (event) => {
        const file = event.target.files[0];

        if (file) {
            const formData = new FormData();
            formData.append("cover_pic", file);
            formData.append("first_name", userDetails?.firstName);
            formData.append("last_name", userDetails?.lastName);

            const response = await dispatch(postPersonalCoverImageReducer(formData));
         
            if (response?.payload?.statusCode === 200) {


                const updatedProfile = await dispatch(getPersonalInfoReducer());

                if (updatedProfile?.payload?.statusCode === 200) {
                    setBgImage(updatedProfile?.payload?.data?.user_cover_url);
                    setPersonalEdited((prev) => ({
                        ...prev,
                        coverPic: updatedProfile?.payload?.data?.user_cover_url,
                    }));
                }
            }

            // settriggeredApi((prevState) => ({
            //     ...prevState,
            //     personalMyprofile: true
            // }));

            // // await handleBlobUpload(file, setBgImage, (url) => updatePersonalDetails({ coverPic: url }), 'cover');
            // const imageUrl = URL.createObjectURL(file);
            // setSelectedBgImage(imageUrl);
            // setSelectedBgFile(file);
            // setOpenRectCropper(true);
            // bgImageRef.current.value = null; // Reset the file input value
        } else { }
    };

    const handleBlobUpload = async (file, stateUpdate, contextUpdate, type) => {
        if (!file) {
            console.error("No File to upload");
            return;
        }
        try {
            const formData = new FormData();
            formData.append("profile_pic", file);
            formData.append("first_name", userDetails?.firstName);
            formData.append("last_name", userDetails?.lastName);

            const response = await dispatch(postPersonalProfileImageReducer(formData));
            // settriggeredApi((prevState) => ({
            //     ...prevState,
            //     personalMyprofile: true
            // }));

            if (response?.payload?.statusCode === 200) {
                const updatedProfile = await dispatch(getPersonalInfoReducer());

                if (updatedProfile?.payload?.statusCode === 200) {
                    setprofilePicturePersonal(updatedProfile?.payload?.data?.user_profile_url);
                    setPersonalEdited((prev) => ({
                        ...prev,
                        profilePic: updatedProfile?.payload?.data?.user_profile_url,
                    }));
                }

                setSelectedFile(null);
                setSelectedImage(null);
            }

            // const formData = new FormData();
            // formData.append('file', file);
            // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data',
            //     },
            // });
            // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/userprofile/personal_profile`, formData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data',
            //     },
            // });
            // const sasUrl = response.data.url;
            // console.log("File uploaded successfully!", sasUrl);
            // stateUpdate(sasUrl);
            // contextUpdate(sasUrl);
            // openSnackbar('File Uploaded Successfully', 1000)]
            // const imageUrl = "https://qaneoinindividuals.blob.core.windows.net/personalprofile/100002_personal_profile_pic_T1738573984359.png?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2026-01-24T14:13:12Z&st=2025-01-24T06:13:12Z&spr=https,http&sig=U28oPRSkpGh2FB03UHLUj9KuYTPTc1uAp0JBBFcTGQY%3D"
            // await saveImageBlob(type);
        } catch (error) {
            console.error('Error uploading file:', error.message);
            alert('Error uploading file. Please check the console for details.');
        }
    }

    // const saveImageBlob = async (imageUrl, type) => {
    //     try {
    //         console.log("Personal Info Save Clicked!");
    //         let updatedDetails = {
    //             first_name: userFirstName,
    //             last_name: userLastName
    //         }
    //         console.log("USER DETAILSSSS", updatedDetails);
    //         if (type === 'cover') {
    //             updatedDetails = {
    //                 ...updatedDetails,
    //                 ...{ cover_pic: imageUrl },
    //             }
    //         } else if (type === 'profile') {
    //             updatedDetails = {
    //                 ...updatedDetails,
    //                 ...{ profile_pic: imageUrl },
    //             }
    //         }
    //         // await callApiFunction('personalInfoUpdate', updatedDetails);
    //         const response = await dispatch(postPersonalProfileReducer(updatedDetails));


    //         console.log("REsponse from Personal Profile", response);
    //         // console.log('updatedDetails', updatedDetails);

    //         setPersonalDetails(prevState => ({
    //             ...prevState,
    //             ...updatedDetails
    //         }));
    //         setSelectedFile(null);
    //         setSelectedImage(null);
    //         settriggeredApi((prevState) => ({
    //             ...prevState,
    //             personalMyprofile: true
    //         }));
    //     } catch (error) {
    //         console.log('Error saving Uploaded Picture');
    //     }
    // }

    const [openCropper, setOpenCropper] = useState(false);
    const handleCropClose = () => {
        setOpenCropper(false);
        setSelectedFile(null);
        setSelectedImage(null);
    }

    const avatarStyles = {
        bgcolor: "#F4F7FE",
        width: isSmallLaptop ? "8rem" : "10rem", // Adjust size based on screen width
        height: isSmallLaptop ? "8rem" : "10rem",
    };



    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const profilePicRef = useRef(null);
    const [profilePicturePersonal, setprofilePicturePersonal] = useState(PersonalEdited?.profilePic || defaultprofile);

    const handleProfilePicChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setSelectedImage(imageUrl);
            setSelectedFile(file);
            setOpenCropper(true);
            setprofilePicturePersonal(PersonalEdited?.profilePic);
            profilePicRef.current.value = null; // Reset the file input value
        } else {
            // Handle the cancel action here if needed
        }
    }

    const handleSaveCroppedImage = async (croppedFile) => {
        await handleBlobUpload(
            croppedFile,
            setprofilePicturePersonal(croppedFile), // Update profile picture state
            (url) => setPersonalEdited((prev) => ({ ...prev, profilePic: url })), // Update context
            'profile' // Specify type (could be 'cover' for cover pic)
        );
    };

    const handleSaveBgImage = async (croppedFile) => {
        await handleBlobUpload(croppedFile, setBgImage, (url) => setPersonalEdited((prev) => ({ ...prev, coverPic: url })), 'cover');
    }

    // const handleProfilePicChange = async (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         await handleBlobUpload(file, setprofilePicturePersonal, (url) => updatePersonalDetails({ profilePic: url }), 'profile');
    //         // console.log('PersonalDetails.profilePic', PersonalDetails?.profilePic);
    //         // await saveImageBlob(PersonalDetails.profilePic, 'profile');
    //         // Revoke the previous URL to manage memory
    //         // if (profilePicturePersonal) {
    //         //     URL.revokeObjectURL(profilePicturePersonal);
    //         // }
    //     } else {
    //         // Handle the cancel action here if needed
    //     }
    // }

    //Success and Failure ---------------------------------------------------------------------
    const handleSuccess = (message = '', op = 'Save') => {
        let successMessage;
        if (op === 'Delete')
            successMessage = message && message !== '' ? message : 'Deleted Successfully!';
        else if (op === 'Save')
            successMessage = message && message !== '' ? message : 'Saved Successfully!';
        openSnackbar(successMessage, 'success', 3000)
    };

    const handleFailure = (message = '', op = 'Save') => {
        let failureMessage;
        if (op === 'Delete')
            failureMessage = message && message !== '' ? message : 'Failed to Delete. Try Again.';
        else if (op === 'Save')
            failureMessage = message && message !== '' ? message : 'Failed to Save. Try Again.';
        openSnackbar(failureMessage, 'error', 3000)
    };

    // -------------------------------------------------Added Newly ---------------------------


    const handleaboutmeSave = () => {
        updatePersonalDetails({ "aboutme": text });
        setAboutOpen(false);
    }
    const updatePersonalDetails = (updatedDetails) => {
        setPersonalEdited((prevDetails) => ({
            ...prevDetails,
            ...updatedDetails,
        }));

        // setPersonalHobbies((prevDetails) => ({
        //     ...prevDetails,
        //     ...updatedDetails,
        // }));

    };



    const handleEditClick = () => {
        setisEdit(!isEdit);
    };

    const handlePersonalSave = () => {
        setPersonalDetails(prevState => ({
            ...prevState,
            ...PersonalEdited
        }));
        setisEdit(false);
    }

    const handlePersonalEditChange = (field) => (event) => {
        setPersonalEdited({
            ...PersonalEdited,
            [field]: event.target.value,
        });
    };
    const [openModalSkills, setOpenModalSkills] = useState(false);
    const [isSkillEdit, setisSkillEdit] = useState(false);
    // const [selectedSkills, setSelectedSkills] = useState(hobbies || []);
    const [openModalLanguage, setOpenLanguage] = useState(false);
    const DefaultLanguages = ['Assamese', 'Bengali', 'English', 'Gujarati', 'Hindi', 'Kannada', 'Kashmiri', 'Konkani', 'Maithlli', 'Malayalam', 'Marathi', 'Odia', 'Punjabi', 'Sanskrit', 'Sindhi', 'Tamil', 'Telugu', 'Urdu'];
    // const [selectLanguage, setSelectLanguage] = useState(personalLanguages || []);
    const [isLanguageEdit, setisLanguageEdit] = useState(false);

    // const handleAddSkill = (skill) => {
    //     console.log("Selected Skill", skill);
    //     if (skill.trim() === '') {
    //         return;
    //     }


    //     const isSkillSelected = personalHobbies.includes(skill);
    //     console.log("Hobbies", isSkillSelected);

    //     let updatedSkills;
    //     if (!isSkillSelected) {
    //         // Remove the skill if it is already selected
    //         // if () {
    //         //     updatedSkills = [...personalHobbies, skill];
    //         //     setPersonalHobbies(updatedSkills);
    //         // } else {
    //         //     handleInfo("Hobbies already included.");
    //         // }

    //         if (!isSkillSelected) {
    //             // If skill is NOT in personalHobbies, add it
    //             updatedSkills = [...personalHobbies, skill];
    //             setPersonalHobbies(updatedSkills);
    //         } else {
    //             // If skill is already in personalHobbies, show info message
    //             handleInfo("Hobbies already included in the List.");
    //             setisSkillEdit(false);
    //             return; // Exit the function to avoid further execution
    //         }

    //     } else {
    //         updatedSkills = personalHobbies.filter((selectedSkill) => selectedSkill !== skill);
    //         setPersonalHobbies(updatedSkills);

    //     }


    //     updatePersonalDetails({ hobbies: updatedSkills });
    //     if (isSkillEdit === false) {
    //         setisSkillEdit(true);
    //     }
    // };

    const handleAddSkill = (skill) => {
        if (skill.trim() === '') {
            return;
        }
        let updatedSkills;

        if (!personalHobbies.includes(skill)) {
            setPersonalHobbies([...personalHobbies, skill]);
        } else {
            updatedSkills = personalHobbies.filter((selectedSkill) => selectedSkill !== skill);
            setPersonalHobbies(updatedSkills);
        }

        updatePersonalDetails({ hobbies: updatedSkills });
        if (isSkillEdit === false) {
            setisSkillEdit(true);
        }
    };



    const handleManualAddSkill = (skill) => {

        if (skill.trim() === '') {
            return;
        }

        let updatedSkills;
        if (!personalHobbies.includes(skill)) {
            setPersonalHobbies([...personalHobbies, skill]);
            updatePersonalDetails({ hobbies: updatedSkills });
            if (isSkillEdit === false) {
                setisSkillEdit(true);
            }
        } else {
            handleInfo("This hobby is already in your list.");
        }
    };


    const handleAddLanguage = (Language) => {
        if (Language.trim() === '') {
            return;
        }
        const isLanguageSelected = personalProfileLanguages.includes(Language);

        let updatedLanguages;
        // If the Language is selected, remove it from the array
        if (isLanguageSelected) {
            updatedLanguages = personalProfileLanguages.filter((selectedLanguage) => selectedLanguage !== Language);

            setPersonalProfileLanguages(updatedLanguages);
            // openSnackbar("Language already in the list!", "info");
            // return;
        } else {
            // If the Language is not selected, add it to the array
            updatedLanguages = [...personalProfileLanguages, Language];
            setPersonalProfileLanguages(updatedLanguages);
        }

        updatePersonalDetails({ personalLanguages: updatedLanguages });
        if (isLanguageEdit === false) {
            setisLanguageEdit(true);
        }
    };


    const handleManualAddLanguage = (language) => {
        if (language.trim() === '') {
            return;
        }

        let updatedLanguages;
        if (!personalProfileLanguages.includes(language)) {
            updatedLanguages = [...personalProfileLanguages, language];
            setPersonalProfileLanguages(updatedLanguages);

            updatePersonalDetails({ personalLanguages: updatedLanguages });
            if (isLanguageEdit === false) {
                setisLanguageEdit(true);
            }
        } else {
            handleInfo('This Language is already in your list.')
        }
    };



    const [anchorElView, setAnchorElView] = useState(null);
    // const [viewOptions, setViewOptions] = useState({
    //     firstName: true,
    //     lastName: true,
    //     dateOfBirth: true,
    //     nickName: true,
    //     personalEmail: true,
    //     phoneNumber: true,
    //     gender: true,
    //     maritalStatus: true,
    //     personAddress: true,
    // });
    const [viewOptions, setViewOptions] = useState(isFieldPublic);
    // local state for user view options
    const [showViewOptions, setShowViewOptions] = useState(true); // state for controlling the display of checkboxes

    // Sync viewOptions with isFieldPublic from context whenever it changes
    // useEffect(() => {
    //     setViewOptions(PersonalDetails.isFieldPublic);
    // }, [PersonalDetails.isFieldPublic]);

    // useEffect(() => {
    //     setViewOptions(isFieldPublic);
    // }, [Personaldata]);

    useEffect(() => {
        if (Personaldata) {
            const updatedFields = {
                firstName: true,
                lastName: true,
                dateOfBirth: Boolean(Personaldata?.is_dob_public),
                nickName: Boolean(Personaldata?.is_nickname_public),
                personalEmail: Boolean(Personaldata?.is_personal_email_public),
                phoneNumber: Boolean(Personaldata?.is_phoneno_public),
                gender: Boolean(Personaldata?.is_gender_public),
                maritalStatus: Boolean(Personaldata?.is_marital_public),
                personAddress: Boolean(Personaldata?.is_address_public),
            };

            setIsFieldPublic(updatedFields);
            setViewOptions(updatedFields); // Ensures checkboxes reflect correct values
        }
    }, [Personaldata]); // Runs only when `Personaldata` changes



    const viewOptionsLabels = {
        firstName: 'First Name',
        lastName: 'Last Name',
        dateOfBirth: 'Date of Birth',
        nickName: 'Nickname',
        personalEmail: 'Personal Email',
        phoneNumber: 'Phone Number',
        gender: 'Gender',
        maritalStatus: 'Marital Status',
        personAddress: 'Address',
    };

    const disabledFields = ['firstName', 'lastName'];

    const viewOptionsOrder = ['firstName', 'lastName', 'dateOfBirth', 'nickName', 'personalEmail', 'phoneNumber', 'gender', 'maritalStatus', 'personAddress'];

    const handleViewOptionsClick = (event) => {
        setAnchorElView(event.currentTarget);
    }

    const handleViewMenuClose = () => {
        setAnchorElView(null);
    }

    // const handleViewCheckboxChange = (event) => {
    //     setViewOptions({
    //         ...viewOptions,
    //         [event.target.name]: event.target.checked,
    //     });
    // };

    const handleViewCheckboxChange = (event) => {
        const { name, checked } = event.target;

        setViewOptions((prev) => ({
            ...prev,
            [name]: checked,
        }));

        setIsFieldPublic((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };



    const calculateAge = (dateOfBirth) => {
        const dob = new Date(dateOfBirth);
        const today = new Date();

        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();

        // If the current date is before the birthday this year, subtract 1 from the age
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }

        return age;
    }

    // Health Info ----------------------------------------------------------------


   
    const [openHealthAlert, setOpenHealthAlert] = useState(false);
    const [healthAlertConfig, setHealthAlertConfig] = useState({});
    const isHealthPopulated = (healthEditState?.allergy?.length > 0 || healthEditState?.medicCondition.length > 0 || healthEditState?.medicHistory.length > 0 || healthEditState?.blood);

    const allergiesOptions = ["Bees", "Dust mites", "Fish", "Lactose", "Latex", "Mold", "Peanuts", "Pollen", "Shellfish", "Soy", "Tree nuts", "Wheat"];
    const medicalConditionsOptions = ["Asthma", "Cancer", "Chronic pain", "Diabetes", "Heart disease", "High blood pressure", "High cholesterol", "Kidney disease", "Liver disease", "Obesity", "Stroke"];
    const medicalHistoryOptions = ["Appendectomy", "Asthma", "Cancer treatment", "Diabetes management", "Heart surgery", "Hypertension treatment", "Kidney transplant", "Liver transplant", "Orthopedic surgery", "Stroke rehabilitation"];

    const handleHealthEditChange = (field) => (event) => {
        setHealthEditState({
            ...healthEditState,
            [field]: event.target.value,
        });
    };

    const handleAddHealthChip = (event, field) => {
        // Ensure that the event is handled only when 'Enter' key is pressed
        if (event.key === 'Enter' && event.target.value.trim()) {
            setHealthEditState((prevState) => {
                // Check if the field in the state is an array
                const fieldValue = prevState[field];
                if (Array.isArray(fieldValue)) {
                    return {
                        ...prevState,
                        [field]: [...fieldValue, event.target.value.trim()]
                    };
                } else {
                    console.error(`${field} is not an array.`);
                    return prevState;
                }
            });
            event.target.value = ''; // Clear the input after adding
            event.preventDefault();
        }
    };

    const handleDeleteHealthChip = (field, chipToDelete) => {
        // console.log('chipToDelete', chipToDelete);
        setHealthEditState((prevState) => ({
            ...prevState,
            [field]: prevState[field].filter((chip) => chip !== chipToDelete)
        }));
    };

    const handleHealthEditClick = () => {
        const { allergy, medicCondition, blood, medicHistory } = healthEditState;
        setHealthEditState({
            allergy,
            medicCondition,
            blood,
            medicHistory,
            medicAttachments: healthEditState?.medicAttachments, // Preserve existing state for medicAttachments
            removedAttachments: healthEditState?.removedAttachments // Preserve existing state for removedAttachments 
        })
        setisHealthEdit(!isHealthEdit);
    }

    // useEffect to sync local health attachments with global on first load
    // useEffect(() => {
    //     setHealthEditState((prevState) => ({
    //         ...prevState,
    //         medicAttachments: healthEditState?.medicAttachments
    //     }))
    // }, [healthEditState?.medicAttachments]);

    useEffect(() => {
        setHealthEditState((prevState) => ({
            ...prevState,
            medicAttachments: HealthDocumentsAttach
        }));
    }, [HealthDocumentsAttach]);

    const updateMedicalAttachments = (newAttachment) => {
        // console.log("Uploaded File:", newAttachment); // Debugging Output

        const maxAttachments = 2;
        const currentAttachments = healthEditState?.medicAttachments || [];

        // Ensure newAttachment is added as an array
        const newAttachmentsArray = [newAttachment];  // ✅ Wrap in an array

        if (currentAttachments.length + newAttachmentsArray.length > maxAttachments) {
            handleOpenHealthAlert({
                title: 'Maximum Attachments Reached',
                message: 'You can only upload a maximum of 2 medical attachments. Remove an existing attachment before trying to upload again.',
                continueFn: () => setOpenHealthAlert(false),
                continueLabel: 'Got it'
            });
        } else {
            setHealthEditState((prevState) => ({
                ...prevState,
                medicAttachments: [...(prevState.medicAttachments || []), ...newAttachmentsArray],  // ✅ Spread correctly
            }));
        }
    };



    // const removeMedicalAttachment = (index) => {
    //     setHealthEditState((prevState) => {
    //         const removed = prevState.medicAttachments[index];
    //         const updatedAttachments = prevState.medicAttachments.filter((_, i) => i !== index);

    //         return {
    //             ...prevState,
    //             medicAttachments: updatedAttachments,
    //             removedAttachments: [...prevState.removedAttachments, removed],
    //         };
    //     });
    // };

    const handleAddMedicalAttachments = (newAttachments) => {
        setHealthEditState((prevState) => ({
            ...prevState,
            medicAttachments: [...prevState.medicAttachments, ...newAttachments]
        }));
    };

    const handleOpenHealthAlert = (config) => {
        setHealthAlertConfig(config);
        setOpenHealthAlert(true);
    }

    const handleCloseHealthAlert = () => {
        setOpenHealthAlert(false);
        setHealthAlertConfig({});
    }

    // const getFileIcon = (filename) => {
    //     const extension = filename.split('.').pop().toLowerCase();
    //     switch (extension) {
    //         case 'pdf':
    //             return <PdfThumb />;
    //         case 'doc':
    //         case 'docx':
    //             return <DocxThumb />;
    //         case 'ppt':
    //         case 'pptx':
    //             return <PptxThumb />
    //         case 'xls':
    //         case 'xlsx':
    //             return <ExcelThumb />
    //         case 'jpg':
    //         case 'jpeg':
    //         case 'png':
    //             return <FaFileImage style={{ color: 'green', fontSize: '2em' }} />;
    //         default:
    //             return <FaFileAlt style={{ color: 'gray', fontSize: '2em' }} />;
    //     }
    // };


    const getFileIcon = (filename) => {
        if (!filename) {
            return <FaFileAlt style={{ color: 'gray', fontSize: '2em' }} />; // Default for undefined/null
        }

        const extension = filename.split('.').pop().toLowerCase();

        switch (extension) {
            case 'pdf':
                return <PdfThumb />;
            case 'doc':
            case 'docx':
                return <DocxThumb />;
            case 'ppt':
            case 'pptx':
                return <PptxThumb />;
            case 'xls':
            case 'xlsx':
                return <ExcelThumb />;
            case 'jpg':
            case 'jpeg':
            case 'png':
                return <FaFileImage style={{ color: 'green', fontSize: '2em' }} />;
            default:
                return <FaFileAlt style={{ color: 'gray', fontSize: '2em' }} />;
        }
    };

    const createObjectURL = (file) => {
        if (file.data.startsWith('http' || 'https')) { // If the argument file is already a URL
            return file.data;
        }

        const base64ToBlob = (base64, mime) => { // If it is base64 encoded
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: mime });
        };

        const blob = base64ToBlob(file.data, file.type);
        return URL.createObjectURL(blob);
    };

    // --------------------------------------Family Member-------------------------------------

    const [isFamilyEdit, setisFamilyEdit] = useState(false);
    const [familyEditState, setFamilyEditState] = useState({
        fatherDet: personalFamilyDetails?.fatherDet,
        motherDet: personalFamilyDetails?.motherDet,
        spouseDet: personalFamilyDetails?.spouseDet,
        kids: personalFamilyDetails?.kids.map(kid => ({ ...kid })) // Use a map to ensure a shallow copy if needed
    });
    const [editMember, setEditMember] = useState(null);
    const [OpenAddFamilyMem, setOpenAddfamily] = useState(false);
    const [newKid, setNewKid] = useState({ id: null, fName: '', lName: '', dob: '', blood: '' });
    const [openAddKidModal, setOpenAddKidModal] = useState(false);
    const [memberKey, setMemberKey] = useState({});
    const [openFamilyAlert, setOpenFamilyAlert] = useState(false);
    const [familyAlertConfig, setFamilyAlertConfig] = useState({});

    const relationNameMap = {
        'fatherDet': 'Father',
        'motherDet': 'Mother',
        'spouseDet': 'Spouse',
        'kids': 'Kid',
    }

    // useEffect(() => {
    //     const { fatherDet, motherDet, spouseDet, kids } = personalFamilyDetails;
    //     setFamilyEditState({ fatherDet, motherDet, spouseDet, kids });
    // }, [personalFamilyDetails?.fatherDet, personalFamilyDetails?.motherDet, personalFamilyDetails?.spouseDet, personalFamilyDetails?.kids])

    const today = new Date().toISOString().split('T')[0];

    // const handleEditFamilyClick = () => {
    //     const { fatherDet, motherDet, spouseDet, kids } = PersonalDetails;
    //     setFamilyEditState({ fatherDet, motherDet, spouseDet, kids });
    //     setisFamilyEdit(!isFamilyEdit);
    // }

    const handleEditMemberClick = (member, index = null) => {
        // console.log("MEMBER", member, "INDEX", index);
        const memberTypeMap = {
            'fatherDet': "Father",
            'motherDet': "Mother",
            'spouseDet': "Spouse",
            'kids': "Kid"
        };
        const memberType = memberTypeMap[member];

        if (member === "kids" && index !== null) {
            setMemberKey({ member, index, memberType }); // Store both member and index for kids
        } else {
            setMemberKey({ member, memberType });
        }

        // Retrieve the selected member's details based on member type
        const selectedMember = (member === "kids" && index !== null) ? personalFamilyDetails?.kids[index] : personalFamilyDetails[member];

        // Update the familyEditState with the selected member's details
        setFamilyEditState((prevState) => {
            const updatedKids = member === "kids" && index !== null
                ? prevState.kids.map((kid, kidIndex) =>
                    kidIndex === index ? { ...selectedMember } : kid)
                : { ...selectedMember };

            return {
                ...prevState,
                [member]: updatedKids
            };
        });

        setisFamilyEdit(!isFamilyEdit);
    };

    // const handleRelationEditChange = (relationType, field) => (event) => {
    //     setPersonalDetails({
    //         ...PersonalDetails,
    //         [`${relationType}Det`]: {
    //             ...PersonalDetails[`${relationType}Det`],
    //             [field]: event.target.value,
    //         },
    //     });
    // };

    const handleFamilyEditChange = (relationType, field) => (event) => {
        const newValue = event.target.value;
        // console.log(`Updating ${relationType} for field ${field}:`, newValue); // Debugging log
        const originalMember = personalFamilyDetails[`${relationType}Det`];

        setFamilyEditState((prevDetails) => ({
            ...prevDetails,
            [`${relationType}Det`]: {
                ...prevDetails[`${relationType}Det`],
                [field]: newValue,
                isVerified: newValue && originalMember.email === newValue && originalMember.phoneNo === prevDetails[`${relationType}Det`].phoneNo,
            },
        }));
    };

    const normalizePhoneNumber = (phoneNumber) => phoneNumber.replace(/\s+/g, '').replace(/[^0-9+]/g, '');

    const handleTelInputChange = (relationType, field) => (phoneNumber) => {
        const originalMember = personalFamilyDetails[`${relationType}Det`];
        const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber);

        setFamilyEditState((prevDetails) => ({
            ...prevDetails,
            [`${relationType}Det`]: {
                ...prevDetails[`${relationType}Det`],
                [field]: phoneNumber || '',
                isVerified: normalizedPhoneNumber && originalMember.phoneNo === normalizedPhoneNumber && originalMember.email === prevDetails[`${relationType}Det`].email,
            },
        }));

        // console.log('newPhoneNumber:', phoneNumber, '\noriginalPhoneNumber', originalMember.phoneNo);
    };

    const handleKidChange = (index, field) => (event) => {
        const value = event.target.value;
        setFamilyEditState((prevDetails) => {
            const updatedKids = [...prevDetails.kids];
            updatedKids[index] = { ...updatedKids[index], [field]: value };
            return { ...prevDetails, kids: updatedKids };
        });
    };

    const handleNewKidChange = (field) => (event) => {
        const value = event.target.value;
        setNewKid((prevKid) => ({ ...prevKid, [field]: value }));
    };

    // const addNewKid = async () => {
    //     try {
    //         // Call the API function to save the updated family info including the new kid
    //         const { fatherDet, motherDet, spouseDet, kids } = {
    //             ...familyEditState,
    //             kids: [...familyEditState.kids, newKid] // Include the new kid here
    //         };

    //         const response = await callApiFunction('familyInfoUpdate', { fatherDet, motherDet, spouseDet, kids, is_public: PersonalDetails.isFamilyPublic });

    //         if (response.status === 'SUCCESS') {
    //             // Update the global state (PersonalDetails) with the new kid
    //             setPersonalDetails(prevState => ({
    //                 ...prevState,
    //                 fatherDet,
    //                 motherDet,
    //                 spouseDet,
    //                 kids // This now includes the newly added kid
    //             }));

    //             // Clear the newKid state and close the modal
    //             setNewKid({ id: null, fName: '', lName: '', dob: '', blood: '' });
    //             setOpenAddKidModal(false);
    //             handleSuccess("New Child Added!")
    //         }
    //     } catch (error) {
    //         console.log('Error adding New Kid AND Saving Family Info');
    //         handleFailure("Could not add another member. Try Again Later.");
    //     } finally {
    //         await getCompletionStatus();
    //     }
    // };

    const addNewKid = async () => {
        try {
            let updatedMember;
            updatedMember = { ...newKid };

            const memberDetails = {
                id: null,
                relative_first_name: updatedMember.fName,
                relative_last_name: updatedMember.lName,
                relative_dob: updatedMember.dob || null,
                relative_blood_group: updatedMember.blood,
                guardian_phone_no: null,
                guardian_email: null,
                is_guardian_verified: false,
                relation_name: "Kid",
            }

            // Prepare the payload to send only the relevant member details
            const payload = {
                memberDetails,
                is_public: isSectionPublic?.Family
            };

            // const response = await callApiFunction('familyInfoUpdate', payload);
            const response = await dispatch(postPersonalProfileFamilyReducer(payload))

            
            if (response?.payload?.statusCode === 200) {
                await dispatch(getPersonalProfileFamilyReducer());
                // Assuming response contains the updated or created member data with ID
                const id = response?.payload?.data?.id; // Adjust based on your response structure

                // Update the state by adding the new kid to the existing array
                // setPersonalDetails((prevState) => ({
                //     ...prevState,
                //     kids: [...prevState.kids, { ...updatedMember, id }] // Append the new kid with the received ID
                // }));


                setPersonalFamilyDetails((prevState) => ({
                    ...prevState,
                    kids: [...prevState.kids, { ...updatedMember, id }] // Append the new kid with ID
                }));
                setNewKid({ id: null, fName: '', lName: '', dob: '', blood: '' });
                // settriggeredApi(true);
                // settriggeredApi((prevState) => ({
                //     ...prevState,
                //     personalfamily: !prevState.personalfamily
                // }));
                setOpenAddKidModal(false);

                await dispatch(getProfileCompletionReducer());
                //  console.log("ADDED NEW KIDD",);
                handleSuccess("New Child Added!");


            }
        } catch (error) {
            console.log('Error adding New Kid AND Saving Family Info');
            handleFailure("Could not add another member. Try Again Later.");
        } finally {
            // await getCompletionStatus();
            // await getPersonalAPIs.getFamilyInfo();
        }
    }

    const handleOpenFamilyAlert = (member) => {
        setOpenFamilyAlert(true);
        setFamilyAlertConfig({
            title: 'Remove this family member?',
            message: 'This is a permanent action. Are you sure you want to remove this member from your family profile?',
            continueFn: () => handleFamilyDeleteMember(member),
            continueLabel: 'Delete'
        })
    }

    const handleCloseFamilyAlert = () => {
        setOpenFamilyAlert(false);
        setFamilyAlertConfig({});
    }

    const handleDeleteKid = (index) => {
        setFamilyEditState((prevDetails) => ({
            ...prevDetails,
            kids: prevDetails.kids.filter((_, kidIndex) => kidIndex !== index)
        }));
    };

    const renderKids = (kidsArray) => (
        kidsArray?.map((kid, index) => (
            <div className="profile-family-block" key={index}>

                <div className="flex-center-between mb-3">
                    <div className="d-block fw-bold">{`${getOrdinalString(index)} Kid`}</div>
                    <div className="flex-center-between">
                        <div className="flex-center pointer" onClick={() => handleEditMemberClick('kids', index)}>
                            <IconButton className="white-icon-hover">
                                <EditIcon className="white-svg" />
                            </IconButton>
                            {/* <div className="sort-icons-cont ms-0">Edit</div> */}
                        </div>
                        <div className="flex-center pointer" onClick={() => handleOpenFamilyAlert(kid)}>
                            <IconButton sx={{ color: "white" }} className="white-icon-hover">
                                <DeleteIcon />
                            </IconButton>
                            {/* <div className="sort-icons-cont ms-0">Delete</div> */}
                        </div>
                    </div>
                </div>
                <FamilyMemberInfo
                    member={kid}
                    handleChange={handleKidChange}
                    isEditMode={false}
                    memberType='Kid'
                    index={index}
                />
            </div>
        ))
    );

    const getAddKidsLabel = () => {
        if (isFamilyEdit) {
            if (familyEditState.kids.length > 0) {
                return "Add More Kids"
            } else {
                return "Add Kids"
            }
        } else {
            if (personalFamilyDetails?.kids.length > 0) {
                return "Add More Kids"
            } else {
                return "Add Kids"
            }
        }
    }

    const [openFamilyVerify, setOpenFamilyVerify] = useState(false);
    const [currentMemberType, setCurrentMemberType] = useState(null);
    const [currentMember, setCurrentMember] = useState(null);
    const [emailOtp, setEmailOtp] = useState('');
    const [phoneOtp, setPhoneOtp] = useState('');
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [isPhoneVerified, setIsPhoneVerified] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [emailOtpSeconds, setEmailOtpSeconds] = useState(60); // Seconds for Email OTP Verification
    const [phoneOtpSeconds, setPhoneOtpSeconds] = useState(60); // Seconds for Phone OTP Verification
    const [isEmailTimerActive, setIsEmailTimerActive] = useState(true);
    const [isPhoneTimerActive, setIsPhoneTimerActive] = useState(false);

    const handleOpenFamilyVerify = () => {
        setisFamilyEdit(false);
        
        setOpenFamilyVerify(true);
        setEmailOtp('');
        setPhoneOtp('');
        setEmailOtpSeconds(60);
        setPhoneOtpSeconds(0)
        setIsEmailVerified(false);
        setIsPhoneVerified(false);
    };

    const handleVerifyMember = async (memberType, member) => {
        setCurrentMemberType(memberType?.toLowerCase());
        setCurrentMember(member);

        let updatedMember = member;
        if (!member.email) {
            updatedMember = { ...member, email: userDetails.email };
            setCurrentMember(updatedMember);
        } else {
            setCurrentMember(member);
        }
        try {
            await sendEmailOtp(updatedMember?.email);
        } catch (error) {
            console.log("Cannot Start Verification:", error)
        }


    };

    const sendEmailOtp = async (email) => {
        setLoading(true);
        try {
            openSnackbar('Sending OTP. Please wait.', "info")
            if (email) {
                const response = await axios.post('onboard/twofactor-second-otp', { email: email }, { headers: headers });
                if (response.status === 200) {
                    // console.log("OTP sent successfully to email");
                    handleOpenFamilyVerify();
                    setEmailError('');
                    setEmailOtp('');
                    setEmailOtpSeconds(60);
                    setIsEmailTimerActive(true);
                }
            }

        } catch (error) {
            console.error("Failed to send OTP to email", error, 'headers', headers);
            openSnackbar('Could not send OTP. Try again later.', "error");
        } finally {
            setLoading(false);
        }
    };

    const sendPhoneOtp = async (phoneNo) => {
        setLoading(true);
        try {
            const response = await axios.post('/mail/Contact-send-mob-otp', { mobileNumber: phoneNo }, { headers: headers });
            if (response.status === 200) {
                // console.log("OTP sent successfully to phone");
                setPhoneError('');
                setPhoneOtp('');
                setIsPhoneTimerActive(true);
                setPhoneOtpSeconds(60);
            }
        } catch (error) {
            console.error("Failed to send OTP to phone", error);
        } finally {
            setLoading(false);
        }
    };

    const verifyEmailOtp = async (email) => {
        if (emailOtpSeconds <= 0) {
            setEmailError('Current OTP time has expired. Click on Resend.');
            return;
        }
        try {
            const response = await axios.post('onboard/twofactor-verify-otp', { email: email, otp: emailOtp }, { headers: headers });
            if (response.status === 200) {
                setIsEmailVerified(true);
                setEmailError('');
                setEmailOtpSeconds(0);
                setIsEmailTimerActive(false);
                // Proceed to phone OTP if needed
                await sendPhoneOtp(currentMember.phoneNo);
            }
        } catch (error) {
            setEmailError('Invalid Email OTP. Try Again.');
            console.log("Failed to verify Email OTP", error);
        }
    };

    const verifyPhoneOtp = async (phoneNo) => {
        if (phoneOtpSeconds <= 0) {
            setPhoneError('Current OTP time has expired. Click on Resend.');
            return;
        }
        try {
            const response = await axios.post('/mail/verify-mobile-otp', { mobileNumber: phoneNo, otp: Number(phoneOtp) }, { headers: headers });
            if (response.status === 200) {
                setIsPhoneVerified(true);
                setPhoneError('');
                setPhoneOtpSeconds(0);
                setIsPhoneTimerActive(false);
                // Handle success logic here
                console.log("Phone OTP verified!")
                setIsPhoneVerified(true);
                // Update the verification status in the state

                setFamilyEditState(prevDetails => {
                    return {
                        ...prevDetails,
                        [`${currentMemberType}Det`]: {
                            ...prevDetails[`${currentMemberType}Det`],
                            isVerified: true, // Set isVerified to true
                        },
                    };
                });
            }
        } catch (error) {
            setPhoneError('Invalid Phone OTP. Try Again.');
            console.log("Failed to verify Phone OTP", error);
        }
    };



    useEffect(() => {
        let interval;
        if (isEmailTimerActive && !isEmailVerified) {
            interval = setInterval(() => {
                setEmailOtpSeconds((prevSeconds) => {
                    if (prevSeconds > 0) return prevSeconds - 1;
                    setIsEmailTimerActive(false);
                    clearInterval(interval);
                    return 0;
                });
            }, 1000);
        }
        if (isPhoneTimerActive && !isPhoneVerified) {
            interval = setInterval(() => {
                setPhoneOtpSeconds((prevSeconds) => {
                    if (prevSeconds > 0) return prevSeconds - 1;
                    setIsPhoneTimerActive(false);
                    clearInterval(interval);
                    return 0;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [isEmailTimerActive, isPhoneTimerActive, isEmailVerified, isPhoneVerified]);

    // API Calling functions
    const handlePersonalInfoSave = async () => {
        try {
            // console.log("Personal Info Save Clicked!");
            const updatedDetails = {
                first_name: PersonalEdited?.firstName,
                last_name: PersonalEdited?.lastName,
                dob: PersonalEdited?.dateOfBirth || userDetails?.dob || null,
                nick_name: PersonalEdited?.nickName || null,
                personal_email: userDetails?.email,
                phone_no: userDetails?.phone,
                gender: PersonalEdited?.gender || null,
                address: PersonalEdited?.personAddress,
                additional_notes: PersonalEdited?.firstName,
                marital_status: PersonalEdited?.maritalStatus || null,
                dobFlag: dobFlag,
                is_address_public: viewOptions?.personAddress,
                is_marital_public: viewOptions?.maritalStatus,
                is_gender_public: viewOptions?.gender,
                is_phoneno_public: viewOptions?.phoneNumber,
                is_personal_email_public: viewOptions?.personalEmail,
                is_nickname_public: viewOptions?.nickName,
                is_dob_public: viewOptions?.dateOfBirth,
            }
            // console.log('PersonalEdited:', PersonalEdited);
            // await callApiFunction('personalInfoUpdate', updatedDetails);
            const response = await dispatch(postPersonalProfileReducer(updatedDetails));
            if (response?.payload?.statusCode === 200) {
                // setPersonalDetails(prevState => ({
                //     ...prevState,
                //     ...PersonalEdited,
                //     ...viewOptions
                // }));

                await dispatch(getPersonalInfoReducer(updatedDetails));

                // setPersonalEdited((prevState) => ({
                //     ...prevState,
                //     firstName: updatedDetails.first_name,
                //     lastName: updatedDetails.last_name,
                //     dateOfBirth: updatedDetails.dob,
                //     nickName: updatedDetails.nick_name,
                //     personalEmail: updatedDetails.personal_email,
                //     phoneNumber: updatedDetails.phone_no,
                //     gender: updatedDetails.gender,
                //     personAddress: updatedDetails.address,
                //     maritalStatus: updatedDetails.marital_status,
                //     isDobAvalaible: updatedDetails.dobFlag,
                // }));
                setisEdit(false);
                // settriggeredApi((prevState) => ({
                //     ...prevState,
                //     personalMyprofile: true
                // }));

                await dispatch(getProfileCompletionReducer());
                handleSuccess();
            }
            // Dispatch to update state

            // Optionally re-fetch updated data
            // dispatch(getPersonalInfoReducer());



        } catch (error) {
            console.log('Error saving Personal Info');
            handleFailure();
        } finally {
            // await getCompletionStatus();
        }
    }

    const handleAboutMeSave = async () => {
        setLoading(true);
        try {
            console.log("AboutMe Save Clicked!");
            const aboutMeText = PersonalEdited?.aboutme.trim();
            const updatedDetails = {
                first_name: userFirstName,
                last_name: userLastName,
                about_me: aboutMeText,
            }
            // await callApiFunction('personalInfoUpdate', updatedDetails);
            const response = await dispatch(postPersonalProfileReducer(updatedDetails));
            // console.log("ABOUT MEE", response?.payload?.statusCode);
            if (response?.payload?.statusCode === 200) {
                // updatePersonalDetails({ "aboutme": aboutMeText });
                // setPersonalDetails(prevState => ({
                //     ...prevState,
                //     ...updatedDetails
                // }));
                await dispatch(getPersonalInfoReducer());

                setPersonalEdited((prevState) => ({
                    ...prevState,
                    aboutme: aboutMeText
                }));
                setText(PersonalEdited?.aboutme);
                setAboutOpen(false);
                handleSuccess();
                settriggeredApi((prevState) => ({
                    ...prevState,
                    personalMyprofile: true
                }));
            }

            // Dispatch to update state

            // Optionally re-fetch updated data
            // dispatch(getPersonalInfoReducer());

        } catch (error) {
            console.log('Error saving AboutMe - Personal Info');
            handleFailure();
        } finally {
            setLoading(false);
        }
    }

    const handleAboutMeSwitch = async (event) => {
        const newVisibility = event.target.checked;
        // console.log("")
        try {
            console.log("AboutMe Switched!");
            const updatedDetails = {
                first_name: userFirstName,
                last_name: userLastName,
                is_about_public: newVisibility
            }
            // const response = await callApiFunction('personalInfoUpdate', updatedDetails);
            const response = await dispatch(postPersonalProfileReducer(updatedDetails));
            if (response?.payload?.statusCode === 200) {
                await dispatch(getPersonalInfoReducer(updatedDetails)); // Dispatch to update state

                // Optionally re-fetch updated data
                // dispatch(getPersonalInfoReducer());
                // setPersonalDetails(prevDetails => ({
                //     ...prevDetails,
                //     isSectionPublic: {
                //         ...prevDetails.isSectionPublic,
                //         aboutme: newVisibility
                //     }
                // }));

                setIsSectionPublic((preDetails) => ({
                    ...preDetails,
                    aboutme: newVisibility
                }));
                settriggeredApi((prevState) => ({
                    ...prevState,
                    personalMyprofile: true
                }));
            }
        } catch (error) {
            console.log('Error Switching AboutMe - Personal Info');
        }
    }

    const handleHealthInfoSave = async () => {
        try {
            console.log("Health Info Save Clicked!");
            const updatedDetails = {
                allergies: healthEditState?.allergy,
                medical_condition: healthEditState?.medicCondition,
                blood_group: healthEditState?.blood,
                medical_history: healthEditState?.medicHistory,
                is_public: isSectionPublic?.Health,
            }

            // console.log("updatedDetailsupdatedDetails", updatedDetails)
            // await callApiFunction('healthInfoUpdate', updatedDetails);
            const response = await dispatch(postPersonalProfileHealthReducer(updatedDetails));

            if (response?.payload?.statusCode === 200) {

                await dispatch(getPersonalProfileHealthReducer());
                // setPersonalDetails(prevState => ({
                //     ...prevState,
                //     ...healthEditState
                // }));
                setisHealthEdit(false);
                handleSuccess();
                // settriggeredApi((prevState) => ({
                //     ...prevState,
                //     personalHealth: true
                // }));
            }

        } catch (error) {
            console.log('Error saving Health Info');
            handleFailure();
        }
    }

    // const handleHealthFilesSave = async () => {
    //     if ((isEqual(healthEditState?.medicAttachments, HealthDocumentsAttach))) {
    //         return;
    //     }
    //     try {
    //         console.log("Health Files Save Clicked!");
    //         const endpoint = 'profileUploadDocuments';

    //         // console.log("healthEditStatemedicAttachmentshealthEditStatemedicAttachments", healthEditState?.medicAttachments)
    //         const documents = healthEditState?.medicAttachments?.map((attachment) => ({
    //             document_name: attachment.name,
    //             document_link: attachment.data,
    //             document_type: attachment.type,
    //             document_meta: {
    //                 document_size: attachment.size
    //             },
    //             is_verified: false,
    //             is_public: false
    //         })) || [];

    //         // const updatedDetails = {
    //         //     section_slug: 'user_health_info',
    //         //     documents: documents
    //         // };
    //         console.log("Health Attachments", documents);
    //         if (documents?.length === 0) {
    //             console.log("No attachments found. Skipping API call.");
    //             return;
    //         }
    //         const formData = new FormData();

    //         formData.append('section_slug', 'user_health_info');

    //         setLoading(true);
    //         handleinfo("Please wait while processing your documents.");

    //         if (documents?.length > 0) {

    //             setLoading(true);
    //             handleinfo("Please wait to complete the process.")
    //             for (let i = 0; i < documents?.length; i++) {
    //                 const fileName = documents[i]?.document_name;
    //                 const documentLink = documents[i]?.document_link;
    //                 const documentType = documents[i]?.document_type;
    //                 console.log("FIlename filename", fileName);
    //                 const response = await fetch(documentLink);
    //                 // console.log("RESPONSE", response);
    //                 const blob = await response.blob();

    //                 const file = new File([blob], fileName, { type: documentType });
    //                 console.log("attachmentsBlob", blob, fileName)
    //                 formData.append("attachments", blob, fileName);
    //             }
    //             setLoading(false);
    //         }

    //         // const response = await callApiFunction(endpoint, updatedDetails);
    //         const response = await dispatch(postHealthBlobReducer(formData))

    //         // console.log("Response", response);
    //         // Clear the removedAttachments array after successful save
    //         if (response?.payload?.statusCode === 200) {
    //             // setPersonalDetails(prevState => ({
    //             //     ...prevState,
    //             //     medicAttachments: healthEditState.medicAttachments,
    //             //     removedAttachments: []  // Clear removed attachments
    //             // }));

    //             // await dispatch(getPersonalHealthDocumentsReducer());
    //             settriggeredApi((prevState) => ({
    //                 ...prevState,
    //                 personalHealth: true,
    //             }));
    //             handleSuccess('Documents Saved Successfully!');
    //         }
    //     } catch (error) {
    //         console.log('Error saving Health Docs');
    //         handleFailure('Could not Save. Try again later.');
    //     }
    // };

    const handleHealthFilesSave = async () => {
        if (isEqual(healthEditState?.medicAttachments, HealthDocumentsAttach)) {
            console.log("No changes detected, skipping API call.");
            return;
        }

        try {
            console.log("Health Files Save Clicked!");

            const documents = healthEditState?.medicAttachments?.map((attachment) => ({
                document_name: attachment?.name || attachment?.document_name,  // Support both uploaded & existing files
                document_link: attachment?.data || attachment?.document_url,  // Handle different sources
                document_type: attachment?.type || attachment?.document_type,
                document_meta: attachment?.size ? { document_size: attachment?.size } : (attachment?.document_meta ? JSON.parse(attachment?.document_meta) : {}),
                is_verified: false,
                is_public: false
            })) || [];


            const formData = new FormData();
            formData.append("section_slug", "user_health_info");

            setLoading(true);
            handleInfo("Please wait while processing your documents.");

            for (let i = 0; i < documents?.length; i++) {
                try {
                    const { document_name, document_link, document_type } = documents[i];

                    // console.log(` Checking Document:`, { document_name, document_link, document_type });

                    // console.log(`Fetching document: ${document_name} from ${document_link}`);

                    const response = await fetch(document_link);
                    if (!response.ok) {
                        throw new Error(` Failed to fetch document: ${document_name}, Status: ${response.status}`);
                    }

                    const blob = await response.blob();
                    // console.log(`Blob created for ${document_name}:`, blob);

                    const file = new File([blob], document_name, { type: document_type });
                    formData.append("attachments", file);
                } catch (fetchError) {
                    // console.error(`🚨 Error Fetching Document: ${fetchError.message}`);
                    handleFailure(`Error Fetching Document: ${fetchError.message}`);
                    setLoading(false);
                    return;
                }
            }

            // console.log(" Final FormData before API call:", formData);

            // API Call
            const response = await dispatch(postHealthBlobReducer(formData));
            console.log(" API Response:", response);

            if (response?.payload?.statusCode === 200) {
                console.log(" Health Documents Uploaded Successfully!");
                await dispatch(getPersonalHealthDocumentsReducer());
                handleSuccess("Documents Saved Successfully!");
            } else {
                // console.error(" API Call Failed:", response);
                throw new Error("API response unsuccessful");
            }
        } catch (error) {
            console.error(" Error in handleHealthFilesSave:", error);
            handleFailure("Could not Save. Try again later.");
        } finally {
            setLoading(false);
        }
    };



    const handleHealthSwitch = async (event) => {
        const newVisibility = event.target.checked;
        try {
            console.log("Health Switched!");
            const updatedDetails = {
                is_public: newVisibility,
                keyword: HEALTH,
            }
            // const response = await callApiFunction('updateVisibility', updatedDetails);
            const response = await dispatch(postPersonalProfileUpdateVisibilityReducer(updatedDetails));
            if (response?.payload?.status === "SUCCESS") {
                await dispatch(getPersonalProfileHealthReducer());
                setIsSectionPublic((prevState) => ({
                    ...prevState,
                    Health: newVisibility,
                }));
            }
        } catch (error) {
            console.log('Error Switching Health', error);
        }
    };

    // const handleFamilyInfoSave = async () => {
    //     try {
    //         console.log("Family Info Save Clicked!");
    //         const { fatherDet, motherDet, spouseDet, kids } = familyEditState;
    //         const response = await callApiFunction('familyInfoUpdate', { fatherDet, motherDet, spouseDet, kids, is_public: PersonalDetails.isFamilyPublic });
    //         if (response.status === 'SUCCESS') {
    //             setPersonalDetails(prevState => ({
    //                 ...prevState,
    //                 fatherDet,
    //                 motherDet,
    //                 spouseDet,
    //                 kids,
    //             }));
    //             settriggeredApi((prevState) => ({
    //                 ...prevState,
    //                 personalfamily: !prevState.personalfamily
    //             }));
    //             setisFamilyEdit(false);
    //             handleSuccess();


    //         }
    //     } catch (error) {
    //         console.log('Error saving Family Info');
    //         handleFailure();

    //     } finally {
    //         await getCompletionStatus();
    //         // await getPersonalAPIs.getFamilyInfo();
    //     }
    // }

    const handleFamilyInfoSave1 = async () => {
        try {
            // Extract the relevant member based on the edit state
            let updatedMember;
            if (memberKey.member === "kids" && memberKey.index !== null) {
                updatedMember = familyEditState?.kids[memberKey?.index];
            } else {
                updatedMember = familyEditState[memberKey?.member];
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const email = updatedMember?.email?.trim() || "";

            const isEmailValid = emailRegex.test(email);

            // Construct memberDetails object
            const memberDetails = {
                id: updatedMember.id || null,
                relative_first_name: updatedMember.fName,
                relative_last_name: updatedMember.lName,
                relative_dob: updatedMember.dob || null,
                relative_blood_group: updatedMember.blood,
                guardian_phone_no: (memberKey?.member !== "kids") ? updatedMember?.phoneNo : null,

                // Only assign guardian_email if it's valid
                guardian_email: (memberKey?.member !== "kids" && isEmailValid) ? email : null,

                // is_guardian_verified: (memberKey?.member !== "kids") ? updatedMember?.isVerified === 1 ? true : false : false,
                is_guardian_verified: (memberKey?.member !== "kids") ? !!updatedMember?.isVerified : false,
                relation_name: relationNameMap[memberKey?.member],
            };


            // Prepare the payload to send only the relevant member details

            const payload = {
                memberDetails,
                is_public: isSectionPublic?.Family
            };

            // const response = await callApiFunction('familyInfoUpdate', payload);
            if (!isEmailValid && updatedMember?.email) {
                // console.warn("Invalid email provided:", updatedMember?.email);
                // You can also show an alert or handle the error accordingly

                handleInfo("Please Add the Valid email.");

            } else {
                const response = await dispatch(postPersonalProfileFamilyReducer(payload))
                // console.log("Family members", response);
                if (response?.payload?.statusCode === 200) {

                    const id = response?.payload?.data?.id; // Get the new ID from the response
                    updatedMember = { ...updatedMember, id }; // Attach the new ID to the updated member data
                    await dispatch(getPersonalProfileFamilyReducer());
                    // Update the global state with the updated member details including the ID
                    setPersonalFamilyDetails((prevState) => {
                        if (memberKey.member === "kids" && memberKey.index !== null) {
                            const updatedKids = prevState.kids.map((kid, index) =>
                                index === memberKey.index ? updatedMember : kid
                            );
                            return { ...prevState, kids: updatedKids };
                        } else {
                            return {
                                ...prevState,
                                [memberKey.member]: updatedMember
                            };
                        }
                    });
                    // settriggeredApi((prevState) => ({
                    //     ...prevState,
                    //     personalfamily: !prevState.personalfamily
                    // }));
                    setisFamilyEdit(false);

                    await dispatch(getProfileCompletionReducer());
                    handleSuccess("Family Details Updated!");

                }
            }

        } catch (error) {
            console.log('Error saving Family Info:', error);
            handleFailure("Could not Save. Try again Later.");
        } finally {
            // await getCompletionStatus();
            // await getPersonalAPIs.getFamilyInfo();
        }
    };

    const handleFamilyDeleteMember = async (member) => {
        try {
            // const endpoint = "familyInfoDelete";
            const id = member?.id;
            // console.log("MEMBER Id", id);
            const params = id;

            // const response = await callApiFunction(endpoint, params);         
            const response = await dispatch(deletePersonalProfileFamilyReducer(id));
            // console.log("DELETE FAMILY MEMBER", response);
            if (response?.payload?.statusCode === 200) {
                setFamilyEditState((prevDetails) => ({
                    ...prevDetails,
                    kids: prevDetails.kids.filter((kid) => kid.id !== id)
                }));
                setPersonalFamilyDetails((prevDetails) => ({
                    ...prevDetails,
                    kids: prevDetails.kids.filter((kid) => kid.id !== id)
                }));

                await dispatch(getPersonalProfileFamilyReducer());

                handleSuccess("Family Member Removed!", "Delete");

            }
        } catch (error) {
            console.log("Error deleting Family Member:", error);
            handleFailure("Could not remove Family Member. Try again later.")
        }
    }

    const handleFamilySwitch = async (event) => {
        const newVisibility = event.target.checked;
        try {
            console.log("Family Switched!");
            const updatedDetails = {
                is_public: newVisibility,
                keyword: FAMILY,
            }
            // const response = await callApiFunction('updateVisibility', updatedDetails);
            const response = await dispatch(postPersonalProfileUpdateVisibilityReducer(updatedDetails));
            if (response?.payload?.status === 'SUCCESS') {

                setIsSectionPublic((prevState) => ({
                    ...prevState,
                    Family: newVisibility,
                }));
            }
        } catch (error) {
            console.log('Error Switching Family', error);
        }
    };

    const handleHobbiesSave = async () => {
        try {
            // console.log("Hobbies Save ======== isSectionPublic:", isSectionPublic);
            // const updatedDetails = {
            //     data: PersonalDetails.hobbies,
            //     is_public: isSectionPublic.hobbies
            // }

            const updatedDetails = {
                data: personalHobbies, // Ensuring an array is sent
                is_public: isSectionPublic?.hobbies
            };
            // await callApiFunction('hobbiesUpdate', updatedDetails);
            const response = await dispatch(postPersonalProfileHobbiesReducer(updatedDetails));
            if (response?.payload?.statusCode === 200) {
                // setPersonalDetails(prevState => ({
                //     ...prevState,
                //     ...updatedDetails
                // }));
                setisSkillEdit(false);
                handleSuccess();

                await dispatch(getPersonalProfileHobbiesReducer());


                // settriggeredApi((prevState) => ({
                //     ...prevState,
                //     personlaHobbies: true
                // }));
            }

        } catch (error) {
            console.log('Error saving Skills Info', error);
            handleFailure();
        }
    }

    const handleHobbiesSwitch = async (event) => {
        const newVisibility = event.target.checked;
        try {
            console.log("Hobbies Switched!");
            const updatedDetails = {
                is_public: newVisibility,
                keyword: HOBBIES
            }
            // const response = await callApiFunction('updateVisibility', updatedDetails);
            const response = await dispatch(postPersonalProfileUpdateVisibilityReducer(updatedDetails));
            // console.log("UVIBILITYYYYYYY", response?.payload?.status);
            if (response?.payload?.status === "SUCCESS") {
                // setPersonalDetails(prevDetails => ({
                //     ...prevDetails,
                //     isSectionPublic: {
                //         ...prevDetails.isSectionPublic,
                //         hobbies: newVisibility
                //     }
                // }));
                await dispatch(getPersonalProfileHobbiesReducer());
                setIsSectionPublic((preDetails) => ({
                    ...preDetails,
                    hobbies: newVisibility
                }))

                // settriggeredApi((prevState) => ({
                //     ...prevState,
                //     personlaHobbies: true
                // }));
            }
        } catch (error) {
            console.log('Error Switching Hobbies - Personal Info');
        }
    }

    const handlePersonalLangSave = async () => {
        try {
            // console.log("Languages Save ======== isSectionPublic:", isSectionPublic);
            const updatedDetails = {
                data: personalProfileLanguages,
                is_public: isSectionPublic?.languages,
                profile_section: "my_personal_profile"
            }
            // console.log("Language   updatedDetailsupdatedDetails", updatedDetails);


            // await callApiFunction('languagesUpdate', updatedDetails);
            const response = await dispatch(postPersonalProfileLanguagesReducer(updatedDetails));
            if (response?.payload?.statusCode === 200) {
                // setPersonalDetails(prevState => ({
                //     ...prevState,
                //     ...updatedDetails
                // }));
                await dispatch(getPersonalProfileLanguagesReducer());
                setisLanguageEdit(false);
                handleSuccess();
                // settriggeredApi((prevState) => ({
                //     ...prevState,
                //     personalLanguage: true
                // }));
            }

        } catch (error) {
            console.log('Error saving Personal Languages');
            handleFailure();
        }
    }

    const handleLanguageSwitch = async (event) => {
        const newVisibility = event.target.checked;
        try {
            console.log("Language Switched!");
            const updatedDetails = {
                is_public: newVisibility,
                keyword: LANGUAGE
            }
            // const response = await callApiFunction('updateVisibility', updatedDetails);
            const response = await dispatch(postPersonalProfileUpdateVisibilityReducer(updatedDetails));
            // console.log("VISIBILITY", response?.payload);
            if (response?.payload?.status === "SUCCESS") {
                // setPersonalDetails(prevDetails => ({
                //     ...prevDetails,
                //     isSectionPublic: {
                //         ...prevDetails.isSectionPublic,
                //         languages: newVisibility
                //     }
                // }));
                await dispatch(getPersonalProfileLanguagesReducer());

                setIsSectionPublic(prevDetails => ({
                    ...prevDetails,
                    languages: newVisibility,
                }))
            }
        } catch (error) {
            console.log('Error Switching Hobbies - Personal Info');
        }
    }

    const handleGenerateAboutMe = async () => {
        if (!PersonalEdited?.aboutme) {
            openSnackbar("Empty data! Please enter some data for generating content!", "error", 8000);
            return;
        }
        openSnackbar("Generating your content...", "info");

        const prompt = {
            aboutMe: PersonalEdited?.aboutme,
            hobbies: personalHobbies,
            languages: personalProfileLanguages,
        }
        try {
            // const response = await callApiFunction('generateAboutMePersonal', { prompt: prompt });
            const response = await dispatch(postPersonalProfileGenerateAboutMeReducer({ prompt }));
            // console.log("ABoutmeABoutme", response?.payload);
            if (response?.payload?.statusCode === 200) {
                const generatedata = response?.payload?.data?.aboutMe;
                // console.log("About me about me", generatedata);
                // setText(responseData.aboutMe);
                if (generatedata) {
                    setPersonalEdited((prevState) => ({
                        ...prevState,
                        aboutme: generatedata
                    }));
                }
            }
        } catch (error) {
            console.error('Failed to Rewrite content with AI', error);
            openSnackbar("Could Not Rewrite your content. Try Again Later.", "error")
        }
    }

    // useEffect(() => {
    //     setBgImage(bgImage || bg_image);
    //     setprofilePicturePersonal(profilePicturePersonal || userDetails.proFile);
    //     // setText(PersonalEdited?.aboutme);
    //     // setSelectedSkills(PersonalDetails.hobbies || []);
    // }, [Personaldata]);

    const renderMenuContent = () => {
        switch (activeMenu) {
            case 'my_profile':
                return (
                    <div>
                        <div className="about-me-personal text-left">
                            <div className="form-display-title">
                                <h2 className="headingforContent mb-0">About Me</h2>
                                <div className="prof-profile-tab-actions">
                                    <div className="flex-center">
                                        <IconButton onClick={() => { setAboutOpen(true) }}>
                                            <EditIcon />
                                        </IconButton>
                                        <div className="sort-icons-cont">Edit</div>
                                    </div >
                                    <FormGroup>
                                        <FormControlLabel control={<Switch checked={isSectionPublic?.aboutme} onChange={handleAboutMeSwitch} />} label={isSectionPublic?.aboutme ? "Public" : "Private"} />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="text-left m-0 p-0 line-break">{PersonalEdited?.aboutme}</div>
                        </div>

                        <div className="about-me-personal">
                            <div className="form-display-title mb-3">
                                <h2 className="headingforContent mb-0">Personal Information</h2>
                                <div className="prof-profile-tab-actions">
                                    <div className="flex-center" onClick={handleEditClick}>
                                        <IconButton>
                                            <EditIcon className={`${isEdit ? 'color-blue' : ''}`} />
                                        </IconButton>
                                        <div className={`sort-icons-cont ${isEdit ? 'color-blue' : ''}`}>Edit</div>
                                    </div>

                                    {/* <div className="flex-center" onClick={isEdit ? handleViewOptionsClick : undefined}>
                                        <IconButton disabled={!isEdit}>
                                            <ViewOptionsIcon className={`${isEdit ? 'color-blue' : ''}`} />
                                        </IconButton>
                                        <div className={`sort-icons-cont ${isEdit ? 'color-blue' : 'pointer-unset'}`}>View</div>
                                    </div>
                                    <Menu
                                        anchorEl={anchorElView}
                                        open={Boolean(anchorElView)}
                                        onClose={handleViewMenuClose}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                                        transformOrigin={{ vertical: 'top', horizontal: "center", }}
                                        className="profile-popup-menu view-options-menu mt-1"
                                    >
                                        <Box sx={{ p: 4 }}>
                                            <IconButton style={{ position: "absolute", top: "8px", right: "8px" }} color="rgb(0, 0, 0, 0.54)" onClick={handleViewMenuClose}>
                                                <CloseRoundedIcon />
                                            </IconButton>
                                            <div className="text-center mb-3">
                                                <div className="menu-title"> Customize User View </div>
                                                <div className="menu-subtitle"> Manage what information needs to be shared </div>
                                            </div>
                                            <div className="view-options-checkboxes">
                                                {Object.keys(viewOptions).map((option) => (
                                                    <div className="view-options-checkbox-item" key={option}>
                                                        <div className={disabledFields.includes(option) ? 'disabled-text' : ''}>
                                                            {viewOptionsLabels[option]}
                                                        </div>

                                                        <Checkbox
                                                            checked={viewOptions[option]}
                                                            onChange={handleViewCheckboxChange}
                                                            name={option}
                                                            color="primary"
                                                            disabled={disabledFields.includes(option)}
                                                        />

                                                    </div>
                                                ))}
                                            </div>
                                        </Box>
                                    </Menu> */}
                                </div>
                            </div>

                            {/* <div className="my-2 user-details-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Grid container direction="column" spacing={2}>
                                            <Grid item>
                                                <TextField
                                                    // value={isEdit ? PersonalEdited.firstName : PersonalDetails.firstName}
                                                    value={userDetails.name.split(' ')[0]}
                                                    label="First Name"
                                                    fullWidth
                                                    disabled
                                                    onChange={handlePersonalEditChange('firstName')}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Date of Birth"
                                                    type="date"
                                                    value={userDetails?.dob || PersonalEdited?.dateOfBirth}
                                                    onChange={handleDOBChange}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    inputProps={{
                                                        max: today
                                                    }}
                                                    fullWidth
                                                    disabled={userDetails?.dob ? true : !isEdit}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Personal Email"
                                                    fullWidth
                                                    // value={isEdit ? PersonalEdited.personalEmail : PersonalDetails.personalEmail}
                                                    value={userDetails?.email}
                                                    onChange={handlePersonalEditChange('personalEmail')}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        name="Gender"
                                                        label="Gender"
                                                        required
                                                        select
                                                        value={isEdit ? PersonalEdited.gender : PersonalDetails.gender}
                                                        onChange={handlePersonalEditChange('gender')}
                                                        InputLabelProps={{ required: false }}
                                                        className='textfield-widthNew'
                                                        disabled={!isEdit}
                                                    >
                                                        <MenuItem value="Male">Male</MenuItem>
                                                        <MenuItem value="Female">Female</MenuItem>
                                                        <MenuItem value="Others">Others</MenuItem>
                                                    </TextField>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Grid container direction="column" spacing={2}>
                                            <Grid item>
                                                <TextField
                                                    // value={isEdit ? PersonalEdited.lastName : PersonalDetails.lastName}
                                                    value={userDetails.name.split(' ')[1]}
                                                    label="Last Name"
                                                    fullWidth
                                                    disabled
                                                    onChange={handlePersonalEditChange('lastName')}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Nickname"
                                                    fullWidth
                                                    value={isEdit ? PersonalEdited.nickName : PersonalDetails.nickName}
                                                    onChange={handlePersonalEditChange('nickName')}
                                                    disabled={!isEdit}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label="Phone Number"
                                                    fullWidth
                                                    // value={isEdit ? PersonalEdited.phoneNumber : PersonalDetails.phoneNumber}
                                                    onChange={handlePersonalEditChange('phoneNumber')}
                                                    value={userDetails?.phone}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        name="MaritalStatus"
                                                        label="Marital Status"
                                                        required
                                                        select
                                                        value={isEdit ? PersonalEdited.maritalStatus : PersonalDetails.maritalStatus}
                                                        onChange={handlePersonalEditChange('maritalStatus')}
                                                        InputLabelProps={{ required: false }}
                                                        className='textfield-widthNew'
                                                        disabled={!isEdit}
                                                    >
                                                        <MenuItem value="Single">Single</MenuItem>
                                                        <MenuItem value="Married">Married</MenuItem>
                                                        <MenuItem value="Others">Others</MenuItem>
                                                    </TextField>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid item>
                                            <TextField
                                                label="Address"
                                                className='summary-field'
                                                fullWidth
                                                value={isEdit ? PersonalEdited.personAddress : PersonalDetails.personAddress}
                                                onChange={handlePersonalEditChange('personAddress')}
                                                disabled={!isEdit}
                                                inputProps={{ spellCheck: false, maxLength: 200 }}
                                                multiline
                                                placeholder="Max Characters 200"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {isEdit && (
                                    <div className='mt-3 d-flex justify-content-end'>
                                        <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handlePersonalInfoSave}>Save</Button>
                                    </div>
                                )}
                            </div> */}
                            <div className="shared-profile-view">
                                <div className="personal-details">
                                    <Grid container spacing={2}>
                                        {(userFirstName) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                      <SmallUserIcon className="custom-icon" />  Name:{" "}
                                                    </span>
                                                    <div className="ms-1">{userFirstName}{" "}{userLastName}</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(PersonalEdited?.dateOfBirth && isFieldPublic?.dateOfBirth) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                        <CalendarIcon className="custom-icon" /> Age:{" "}
                                                    </span>
                                                    <div className="ms-1">{calculateAge(PersonalEdited?.dateOfBirth)} Years Old</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(userDetails?.phone && isFieldPublic?.phoneNumber) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                        <CallRoundedIcon className="custom-icon" /> Phone Number:{" "}
                                                    </span>
                                                    <div className="ms-1">{userDetails?.phone}</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(userDetails?.email && isFieldPublic?.personalEmail) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                        <EmailRounded className="custom-icon" /> E-mail ID:{" "}
                                                    </span>
                                                    <div className="ms-1">{userDetails?.email}</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(PersonalEdited?.nickName && isFieldPublic?.nickName) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                        <SmallUserIcon className="custom-icon" /> Nickname:{" "}
                                                    </span>
                                                    <div className="ms-1">{PersonalEdited?.nickName}</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(PersonalEdited?.gender && PersonalEdited?.gender !== "Prefer not to say" && isFieldPublic?.gender) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                        <GenderIcon className="custom-icon" /> Gender:{" "}
                                                    </span>
                                                    <div className="ms-1">{PersonalEdited?.gender}</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(PersonalEdited?.maritalStatus && isFieldPublic?.maritalStatus) &&
                                            <Grid item xs={6}>
                                                <div>
                                                    <span className="span-center-align">
                                                        {PersonalEdited?.maritalStatus === 'Married' ? <MarriedIcon className="custom-icon" /> :
                                                            (PersonalEdited?.gender === 'Female' ? <SingleFemaleIcon className="custom-icon" /> : <SingleMaleIcon className="custom-icon" />)
                                                        } Marital Status:{" "}
                                                    </span>
                                                    <div className="ms-1">{PersonalEdited?.maritalStatus}</div>
                                                </div>
                                            </Grid>
                                        }
                                        {(PersonalEdited?.personAddress && isFieldPublic?.personAddress) &&
                                            <Grid item xs={12}>
                                                <div>
                                                    <span className="span-center-align">
                                                        <AddressIcon className="custom-icon" /> Address:{" "}
                                                    </span>
                                                    <div className="ms-1">{PersonalEdited?.personAddress}</div>
                                                </div>
                                            </Grid>
                                        }
                                    </Grid>
                                </div>
                            </div>

                        </div>

                        <div className="p-3 mt-2 professional-page-section">
                            <div className="mt-1 mb-3 d-flex justify-content-between align-items-center">
                                <h2 className="mb-0 headingforContent">Personal Interest/Hobbies</h2>
                                <div className="prof-profile-tab-actions">
                                    <div className="flex-center" onClick={() => { setOpenModalSkills(true) }}>
                                        <IconButton>
                                            <AddCircleRoundedIcon />
                                        </IconButton>
                                        <div className="sort-icons-cont">Add</div>
                                    </div >
                                    <div className="flex-center" onClick={() => { setisSkillEdit(!isSkillEdit) }}>
                                        <IconButton>
                                            <EditIcon className={`${isSkillEdit ? 'color-blue' : ''}`} />
                                        </IconButton>
                                        <div className={`sort-icons-cont  ${isSkillEdit ? 'color-blue' : ''}`}>Edit</div>
                                    </div>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch checked={isSectionPublic?.hobbies} onChange={handleHobbiesSwitch} />} label={isSectionPublic?.hobbies ? "Public" : "Private"} />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="skills-list-professional">
                                {personalHobbies?.map((skill, index) => (
                                    <SkillItem key={skill} label={skill} isEdit={isSkillEdit} onAdd={handleAddSkill} />
                                ))}
                                <SkillItemForNewAddItem selectedSkills={personalHobbies} onAdd={handleManualAddSkill} label={"Type Hobbies"} />
                            </div>
                            {
                                isSkillEdit &&
                                <div className='mt-3 d-flex justify-content-end'>
                                    <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleHobbiesSave}>Save</Button>
                                </div>
                            }
                        </div>

                        <div className="p-3 mt-2 professional-page-section">
                            <div className="mt- mb-3 d-flex justify-content-between align-items-center">
                                <h2 className="mb-0 headingforContent">Languages</h2>
                                <div className="prof-profile-tab-actions">
                                    <div className="flex-center" onClick={() => { setOpenLanguage(true) }}>
                                        <IconButton>
                                            <AddCircleRoundedIcon />
                                        </IconButton>
                                        <div className="sort-icons-cont">Add</div>
                                    </div >
                                    <div className="flex-center" onClick={() => { setisLanguageEdit(!isLanguageEdit) }}>
                                        <IconButton>
                                            <EditIcon className={`${isLanguageEdit ? 'color-blue' : ''}`} />
                                        </IconButton>
                                        <div className={`sort-icons-cont  ${isLanguageEdit ? 'color-blue' : ''}`}>Edit</div>
                                    </div >
                                    <FormGroup>
                                        <FormControlLabel control={<Switch checked={isSectionPublic?.languages} onChange={handleLanguageSwitch} />} label={isSectionPublic?.languages ? "Public" : "Private"} />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="skills-list-professional">
                                {personalProfileLanguages?.map((skill, index) => (
                                    <SkillItem key={skill} label={skill} isEdit={isLanguageEdit} onAdd={handleAddLanguage} />
                                ))}
                                <SkillItemForNewAddItem selectedSkills={personalProfileLanguages} onAdd={handleManualAddLanguage} label={"Type Languages"} />
                            </div>
                            {
                                isLanguageEdit &&
                                <div className='mt-3 d-flex justify-content-end'>
                                    <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handlePersonalLangSave}>Save</Button>
                                </div>
                            }
                        </div>
                    </div>
                );
            case 'health':
                return (<>
                    <div>
                        <div className="about-me-personal">
                            <div className="d-flex justify-content-between align-items-center">
                                <h2 className="headingforContent">Health Information</h2>
                                <div className="prof-profile-tab-actions">
                                    <div className="flex-center" onClick={handleHealthEditClick}>
                                        <IconButton>
                                            <EditIcon className={`${isHealthEdit ? 'color-blue' : ''}`} />
                                        </IconButton>
                                        <div className={`sort-icons-cont ${isHealthEdit ? 'color-blue' : ''}`}>Edit</div>
                                    </div>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch checked={isSectionPublic?.Health} onChange={handleHealthSwitch} />} label={isSectionPublic?.Health ? "Public" : "Private"} />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="my-2 user-details-container shared-profile-view">
                                {isHealthPopulated ?
                                    (
                                        <div className="personal-details health-info">
                                            {(Array.isArray(healthEditState?.allergy) && healthEditState?.allergy.length > 0) &&
                                                <div>
                                                    <strong className="list-display-title">Allergies:</strong>
                                                    {healthEditState?.allergy?.map((item, index) => (
                                                        index !== healthEditState?.allergy.length - 1 ? item + ", " : item
                                                    ))}
                                                    {/* <div className="chips-display">
                                        {PersonalDetails.allergy.map((item, index) => (
                                            <CustomChip
                                                key={index}
                                                variant="outlined"
                                                label={item}
                                            />
                                        ))} 
                                        </div> */}
                                                </div>
                                            }
                                            {(Array.isArray(healthEditState?.medicCondition) && healthEditState?.medicCondition.length > 0) &&
                                                <div>
                                                    <strong className="list-display-title">Medical Conditions:</strong>
                                                    {healthEditState?.medicCondition.map((item, index) => (
                                                        index !== healthEditState?.medicCondition?.length - 1 ? item + ", " : item
                                                    ))}
                                                </div>
                                            }
                                            {(Array.isArray(healthEditState?.medicHistory) && healthEditState?.medicHistory.length > 0) &&
                                                <div>
                                                    <strong className="list-display-title">Medical History:</strong>
                                                    {healthEditState?.medicHistory.map((item, index) => (
                                                        index !== healthEditState?.medicHistory.length - 1 ? item + ", " : item
                                                    ))}
                                                </div>
                                            }
                                            {(healthEditState?.blood) &&
                                                <div>
                                                    <strong className="list-display-title">Blood Group:</strong> {healthEditState?.blood}
                                                </div>
                                            }
                                        </div>
                                    ) : (<div className="personal-details">
                                        No Health Information Entered! Click on Edit to enter.
                                    </div>)}
                            </div>
                        </div>

                        <div className="about-me-personal">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h2 className="headingforContent">Attach Medical Report</h2>
                            </div>

                            <div className="my-2 user-details-container">
                                <div className='education-list mb-3'>
                                    {healthEditState?.medicAttachments?.length > 0 && (
                                        <>
                                            {healthEditState?.medicAttachments?.map((file, index) => {
                                                // console.log(file?.document_name); // Log only the file name

                                                return (
                                                    <div className="education-item" key={index}>
                                                        <div className="d-flex">
                                                            <div className="documents-logo-container flex-center">
                                                                {getFileIcon(file?.document_name) || file?.name}
                                                            </div>
                                                            <div className="ms-3 institute-details d-flex flex-column text-left">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="file-name margin-bottom-8px">
                                                                        {/* {file?.document_name.split('.')[0]} */}
                                                                        {file?.document_name ? file?.document_name.split('.')[0] : file?.name.split('.')[0]}
                                                                    </div>
                                                                    <IconButton onClick={() => removeHealthMedicalAttachment(index)}>
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                </div>
                                                                <div className="design-lighter-text margin-bottom-8px">
                                                                    Format: {file?.document_name ? file?.document_name.split('.').pop().toUpperCase() : file?.name.split('.').pop().toUpperCase()} | Upload: {file?.date}
                                                                </div>
                                                                <div
                                                                    className="d-flex justify-content-start align-items-center pointer"
                                                                    onClick={() => openDocumentViewer(file)}
                                                                >
                                                                    <div className="Certificate-design me-1">View</div>
                                                                    <VisibilityIcon
                                                                        sx={{ height: '1rem', width: '1rem' }}
                                                                        className="icon-color mt-1"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="divider" />
                                                    </div>
                                                );
                                            })}
                                        </>
                                    )}

                                </div>
                                <FileDragUpload maxSize={5} inputId='health-upload-files ' accept={[...ACCEPT_IMAGE, ...ACCEPT_PDF]} contextUpdate={updateMedicalAttachments} />
                                <div className="text-end mt-3">
                                    <Button
                                        variant="contained"
                                        sx={{ backgroundColor: "#0044C6" }}
                                        onClick={handleHealthFilesSave}
                                        disabled={(isEqual(healthEditState?.medicAttachments, HealthDocumentsAttach))}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>)
            case 'family':
                return (<>
                    <div>
                        <div className="about-me-personal text-left">
                            <div className="d-flex justify-content-between align-items-center">
                                <h2 className="headingforContent">Family Information</h2>
                                <div className="prof-profile-tab-actions">
                                    <div className="flex-center" onClick={() => setOpenAddKidModal(true)}>
                                        <IconButton >
                                            <AddCircleRoundedIcon />
                                        </IconButton>
                                        <div className="sort-icons-cont">{"Add Kids" || getAddKidsLabel()}</div>
                                    </div >
                                    {/* <div className="flex-center" onClick={handleEditFamilyClick}>
                                        <IconButton>
                                            <EditIcon className={`${isFamilyEdit ? 'color-blue' : ''}`} />
                                        </IconButton>
                                        <div className={`sort-icons-cont ${isFamilyEdit ? 'color-blue' : ''}`}>Edit</div>
                                    </div > */}
                                    <FormGroup>
                                        <FormControlLabel control={<Switch checked={isSectionPublic?.Family} onChange={handleFamilySwitch} />} label={isSectionPublic?.Family ? "Public" : "Private"} />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="family-grid-container">

                                <div className="profile-family-block">
                                    <div className="flex-center-between mb-3">
                                        <div className="d-block fw-bold">Father/Guardian</div>
                                        <div className="flex-center" onClick={() => handleEditMemberClick('fatherDet')}>
                                            <IconButton className="white-icon-hover">
                                                <EditIcon className="white-svg" />
                                            </IconButton>
                                            {/* <div className="sort-icons-cont ms-0">Edit</div> */}
                                        </div>
                                    </div>
                                    <FamilyMemberInfo
                                        member={personalFamilyDetails?.fatherDet}
                                        // contextMember={PersonalDetails?.fatherDet}
                                        handleChange={handleFamilyEditChange}
                                        handlePhoneChange={handleTelInputChange}
                                        isEditMode={false}
                                        memberType='Father'
                                        onVerify={handleVerifyMember}
                                    />
                                </div>

                                <div className="profile-family-block">
                                    <div className="flex-center-between mb-3">
                                        <div className="d-block fw-bold">Mother/Guardian</div>
                                        <div className="flex-center" onClick={() => handleEditMemberClick('motherDet')}>
                                            <IconButton className="white-icon-hover">
                                                <EditIcon className="white-svg" />
                                            </IconButton>
                                            {/* <div className="sort-icons-cont ms-0">Edit</div> */}
                                        </div>
                                    </div>
                                    <FamilyMemberInfo
                                        member={personalFamilyDetails?.motherDet}
                                        // contextMember={PersonalDetails?.motherDet}
                                        handleChange={handleFamilyEditChange}
                                        handlePhoneChange={handleTelInputChange}
                                        isEditMode={false}
                                        memberType='Mother'
                                        onVerify={handleVerifyMember}
                                    />
                                </div>

                                <div className="profile-family-block">
                                    <div className="flex-center-between mb-3">
                                        <div className="d-block fw-bold">Spouse</div>
                                        <div className="flex-center" onClick={() => handleEditMemberClick('spouseDet')}>
                                            <IconButton className="white-icon-hover">
                                                <EditIcon className="white-svg" />
                                            </IconButton>
                                            {/* <div className="sort-icons-cont ms-0">Edit</div> */}
                                        </div>
                                    </div>
                                    <FamilyMemberInfo
                                        member={personalFamilyDetails?.spouseDet}
                                        // contextMember={PersonalDetails?.spouseDet}
                                        handleChange={handleFamilyEditChange}
                                        handlePhoneChange={handleTelInputChange}
                                        isEditMode={false}
                                        memberType='Spouse'
                                        onVerify={handleVerifyMember}
                                    />
                                </div>
                            </div>

                            <div>
                                {(isFamilyEdit ? familyEditState?.kids?.length !== 0 : personalFamilyDetails?.kids.length !== 0) && (
                                    <div className="d-flex design-lighter-text mb-1 heading-Lightbox-group">Kids</div>
                                )}

                                {/* {renderKids(isFamilyEdit ? familyEditState.kids : PersonalDetails.kids)} */}
                                <div className="family-grid-container">
                                    {renderKids(personalFamilyDetails?.kids)}
                                </div>

                                {/* {isFamilyEdit && (
                                    <div className='mt-3 d-flex justify-content-end'>
                                        <Button id="familyInfoSaveButton" variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleFamilyInfoSave}>Save</Button>
                                    </div>
                                )} */}
                            </div>


                        </div>
                    </div>
                </>);
            default:
                return (<>Menu not Found</>)
        }
    }

    return (
        <>
            <div className="wrapper">
                <div className="my-profile-bg" style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}>

                    <div className="outiline-editicon flex-center">
                        <label htmlFor="bgImageInput" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                            <EditIcon />
                        </label>
                    </div>
                    <input
                        type="file"
                        onChange={handleBgImageChange}
                        style={{ display: 'none' }}
                        id="bgImageInput"
                        accept="image/*"
                        ref={bgImageRef}
                    />
                    <div className="My-Profile-Scanner-image">
                        {/* <a
                            href={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                            target="_blank"
                            rel="noopener noreferrer"

                        > */}
                        <div className="profile-qr-container flex-center">
                            <QrCodeProfile className="container-gift-2"
                                qrCodeUrl={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`}
                                size={qrCodeSize}
                            />
                        </div>
                        {/* </a> */}
                    </div>
                    <div className="My-Profile-imgOutline flex-center">
                        {/* <img className="myprofilePhoto" src={profilePicturePersonal} alt="profile" /> */}
                        <div>
                            <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                badgeContent={
                                    <Avatar sx={{ bgcolor: "#0044C6" }}>
                                        <label htmlFor="profilePicture-input" style={{ cursor: "pointer" }}>
                                            <EditIcon className="white-svg" />
                                        </label>
                                        <input id="profilePicture-input" ref={profilePicRef} type="file" style={{ display: 'none' }} onChange={handleProfilePicChange} accept={[...ACCEPT_IMAGE]} />
                                    </Avatar>}>
                                <Avatar sx={avatarStyles}>

                                    {profilePicturePersonal ?
                                        (
                                            <img src={profilePicturePersonal} alt="profilepicture" className='profile-pic-avatar' />
                                        ) : (<>
                                            <InsertPhotoIcon sx={{ color: "grey" }} fontSize="large" />
                                        </>
                                        )}

                                </Avatar>
                            </Badge>
                        </div>
                    </div>
                </div>
                <div className="col sec-first second-part-of-Screen">
                    <div className="my-profile-heading-container">
                        <div className="my-profile-heading d-flex flex-column">
                            <span className="my-profile-heading name">{userDetails?.name}</span>
                            {/* <span className="subheading mb-0">{userDetails.profession}</span> */}
                        </div>
                    </div>

                    <div className="my-profile-heading-content mt-1 mb-4">
                        <div className="uid-container">UID: {userDetails?.uniqueId}</div>
                        <div className="profile-meta-info pointer" onClick={() => { setConnectionViewModal(true) }}>
                            <GroupsIcon /> <span className="color-blue">{Personaldata?.connection_count || 0} Connections</span>
                        </div>
                        <Divider orientation="vertical" />
                        <div className="profile-meta-info pointer" onClick={() => { setOpenShareProfile(true) }}>
                            <ShareIcon /> <span> Share </span>
                        </div>
                        <Divider orientation="vertical" />
                        <div className="profile-meta-info pointer" onClick={() => { setOpenInviteProfile(true) }}>
                            <InviteIcon /> <span> Invite </span>
                        </div>
                    </div>

                    <div className="my-profile-actions">
                        <div className="my-profile-status flex-center">
                            <div className="probar">
                                <CircularProgressbarWithChildren
                                    className="profile-completion-bar"
                                    value={profileCompletionPercentage}
                                    styles={buildStyles({
                                        pathColor:
                                            profileCompletionPercentage === 100 ? '#4CAF50' : '#FFA000',
                                        trailColor:
                                            profileCompletionPercentage === 100 ? '#C8E6C9' : '#FFDDA4',
                                        textColor: '#333',
                                        textSize: '10px',
                                    })}
                                >
                                    <div style={{ fontSize: '10px' }}>Status</div>
                                    <div
                                        style={{
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            color: profileCompletionPercentage === 100 ? '#4CAF50' : '#525252',
                                        }}
                                    >
                                        {profileCompletionPercentage}%
                                    </div>
                                </CircularProgressbarWithChildren>
                            </div>
                            <div className="col probar-content">
                                <h3 className="tit">Profile Completion</h3>
                                <p className="tit-cont">
                                    {profileCompletionPercentage === 100 ? (
                                        <>
                                            Well Done! Your Profile is completed.
                                        </>
                                    ) : (
                                        <>
                                            Uh-oh! Looks like your profile and{" "}
                                            <u>
                                                {/* <a href="/countrySelecting">KYC</a>
                                                 */}
                                                <Link to="/countrySelecting">KYC</Link>

                                            </u>{" "}
                                            need some attention for a verified ID.
                                        </>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="p-3">
                    <div className="menu">
                        <Tabs value={activeMenu} onChange={handleMenuClick} aria-label="Profile Tabs"
                            variant="scrollable"
                            scrollButtons="auto"
                            className='custom-profile-tabs'
                            selectionFollowsFocus
                        >
                            <Tab label='My Profile' value='my_profile' />
                            <Tab label='Health' value='health' />
                            <Tab label='Family' value='family' />

                        </Tabs>
                    </div>

                    <div className="rsuite-container">
                        <div className='content-for-Email'>
                            {renderMenuContent()}
                        </div>
                    </div>

                </div>

                {aboutOpen &&
                    <div className="lightbox-overlay">
                        <div className="lightbox-content-2 p-4">
                            <>
                                <div className='d-flex justify-content-between'>
                                    <h6 className='about-me-title mt-2 mb-0'>About Me</h6>
                                    <div className="d-flex about-me-actions">
                                        {/* <div className="d-flex">
                                            <div className="icon flex-center mx-2"> <img src={Aigenerate} alt="aigenerate" /> </div>
                                            <div className="content no-wrap pointer" style={{ whiteSpace: 'nowrap' }}>AI Generate</div>
                                        </div> */}
                                        <Button
                                            variant='outlined'
                                            sx={{ color: '#0044C6' }}
                                            className='ai-rewrite-button'
                                            onClick={handleGenerateAboutMe}
                                            // disabled={status === "recording"}
                                            startIcon={<AiLogo />}>
                                            Generate
                                        </Button>
                                        <IconButton onClick={() => { setAboutOpen(false) }}>
                                            <CloseRoundedIcon />
                                        </IconButton>
                                    </div>
                                </div>
                                <div className="about-me-edit-container mt-3">
                                    <textarea
                                        value={PersonalEdited?.aboutme || ''}
                                        onChange={handlePersonalEditChange("aboutme")}
                                        className="About-me-edit"
                                        maxLength={1000}
                                        placeholder="Write something about yourself"
                                    />
                                    <div className="about-me-edit-count">
                                        {PersonalEdited?.aboutme?.length ? PersonalEdited?.aboutme?.length : 0}/1000
                                    </div>
                                </div>

                                <div className='mt-3 d-flex justify-content-end'>
                                    <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleAboutMeSave}
                                    // disabled={text === PersonalEdited?.aboutme} 
                                    >Save</Button>
                                </div>
                            </>
                        </div>
                    </div>
                }
            </div >

            <Modal open={isEdit} onClose={() => setisEdit(false)}>
                <Box sx={{ width: isSmallLaptop ? "80%" : "65%", maxWidth: "80%", maxHeight: "80%", p: 3 }} className='modal-box-1'>
                    <div className="soc-modal-heading mb-3" style={{ position: "relative" }}>
                        <strong>Edit Personal Information</strong>
                        <span className='span-center-align file-attach-icon-container'>
                            <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => { setisEdit(false); }}>
                                <CloseRoundedIcon />
                            </IconButton></span>
                    </div>
                    <div className="my-2 user-details-container">
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={userFirstName}
                                            label="First Name"
                                            fullWidth
                                            disabled
                                            onChange={handlePersonalEditChange('firstName')}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            value={userLastName}
                                            label="Last Name"
                                            fullWidth
                                            disabled
                                            onChange={handlePersonalEditChange('lastName')}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            label="Date of Birth"
                                            type="date"
                                            value={PersonalEdited?.dateOfBirth || userDetails?.dob}
                                            onChange={handleDOBChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ max: today }}
                                            fullWidth
                                            disabled={true}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Nickname"
                                            fullWidth
                                            value={PersonalEdited?.nickName ?? ""}
                                            onChange={handlePersonalEditChange('nickName')}
                                            disabled={!isEdit}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            label="Personal Email"
                                            fullWidth
                                            value={userDetails?.email}
                                            onChange={handlePersonalEditChange('personalEmail')}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            label="Phone Number"
                                            fullWidth
                                            value={userDetails?.phone}
                                            onChange={handlePersonalEditChange('phoneNumber')}
                                            disabled
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <TextField
                                                name="Gender"
                                                label="Gender"
                                                required
                                                select
                                                value={PersonalEdited?.gender}
                                                onChange={handlePersonalEditChange('gender')}
                                                InputLabelProps={{ required: false }}
                                                className="textfield-widthNew"
                                                disabled={!isEdit}
                                            >
                                                <MenuItem value=""><em>Select</em></MenuItem>
                                                <MenuItem value="Male">Male</MenuItem>
                                                <MenuItem value="Female">Female</MenuItem>
                                                <MenuItem value="Prefer not to say">Prefer not to say</MenuItem>
                                                <MenuItem value="Others">Others</MenuItem>
                                            </TextField>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <TextField
                                                name="MaritalStatus"
                                                label="Marital Status"
                                                required
                                                select
                                                value={PersonalEdited?.maritalStatus}
                                                onChange={handlePersonalEditChange('maritalStatus')}
                                                InputLabelProps={{ required: false }}
                                                className="textfield-widthNew"
                                                disabled={!isEdit}
                                            >
                                                <MenuItem value=""><em>Select</em></MenuItem>
                                                <MenuItem value="Single">Single</MenuItem>
                                                <MenuItem value="Married">Married</MenuItem>
                                                <MenuItem value="Others">Others</MenuItem>
                                            </TextField>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            label="Address"
                                            className="summary-field"
                                            fullWidth
                                            value={PersonalEdited?.personAddress}
                                            onChange={handlePersonalEditChange('personAddress')}
                                            disabled={!isEdit}
                                            inputProps={{ spellCheck: false, maxLength: 200 }}
                                            multiline
                                            placeholder="Max Characters 200"
                                        />
                                    </Grid>

                                    {isEdit && (
                                        <Grid item xs={12}>
                                            <div className='mt-3 d-flex justify-content-end'>
                                                <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handlePersonalInfoSave}>Save</Button>
                                            </div>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>

                        </Grid>
                    </div>
                </Box>
            </Modal>

            <Modal open={isHealthEdit} onClose={() => setisHealthEdit(false)}>
                <Box sx={{ width: "65%", maxWidth: "80%", maxHeight: "80%", p: 3 }} className='modal-box-1'>
                    <div className="soc-modal-heading mb-3" style={{ position: "relative" }}>
                        <strong>Edit Health Information</strong>
                        <span className='span-center-align file-attach-icon-container'>
                            <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => { setisHealthEdit(false); }}>
                                <CloseRoundedIcon />
                            </IconButton></span>
                    </div>
                    <div className="my-2 user-details-container health-section">
                        <Grid container spacing={2}>

                            <Grid item xs={12}>
                                <Autocomplete
                                    freeSolo
                                    options={allergiesOptions}
                                    multiple
                                    PaperComponent={customHealthPaper}
                                    disabled={!isHealthEdit}
                                    value={healthEditState?.allergy}
                                    onChange={(event, newValue) => setHealthEditState({ ...healthEditState, allergy: newValue })}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <CustomChip
                                                key={index}
                                                variant="outlined"
                                                label={option}
                                                onDelete={() => handleDeleteHealthChip('allergy', option)}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Allergies"
                                            onKeyDown={(event) => handleAddHealthChip(event, 'allergy')}
                                            placeholder="Type Allergies"
                                            disabled={!isHealthEdit}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Autocomplete
                                    freeSolo
                                    options={medicalConditionsOptions}
                                    multiple
                                    disabled={!isHealthEdit}
                                    PaperComponent={customHealthPaper}
                                    value={healthEditState?.medicCondition}
                                    onChange={(event, newValue) => setHealthEditState({ ...healthEditState, medicCondition: newValue })}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <CustomChip
                                                key={index}
                                                variant="outlined"
                                                label={option}
                                                onDelete={() => handleDeleteHealthChip('medicCondition', option)}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Medical Conditions"
                                            onKeyDown={(event) => handleAddHealthChip(event, 'medicCondition')}
                                            placeholder="Type Medical Conditions"
                                            disabled={!isHealthEdit}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Autocomplete
                                    freeSolo
                                    options={medicalHistoryOptions}
                                    multiple
                                    disabled={!isHealthEdit}
                                    PaperComponent={customHealthPaper}
                                    value={healthEditState?.medicHistory}
                                    onChange={(event, newValue) => setHealthEditState({ ...healthEditState, medicHistory: newValue })}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <CustomChip
                                                key={index}
                                                variant="outlined"
                                                label={option}
                                                onDelete={() => handleDeleteHealthChip('medicHistory', option)}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Medical History"
                                            onKeyDown={(event) => handleAddHealthChip(event, 'medicHistory')}
                                            placeholder="Type Medical History"
                                            disabled={!isHealthEdit}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        name="bloodGroup"
                                        label="Blood Group"
                                        required
                                        select
                                        value={(healthEditState?.blood) || ''}
                                        onChange={handleHealthEditChange('blood')}
                                        InputLabelProps={{ required: false }}
                                        className='textfield-widthNew'
                                        disabled={!isHealthEdit}
                                    >
                                        <MenuItem value=""><i>Select</i></MenuItem>
                                        <MenuItem value="A+">A+</MenuItem>
                                        <MenuItem value="A-">A-</MenuItem>
                                        <MenuItem value="B+">B+</MenuItem>
                                        <MenuItem value="B-">B-</MenuItem>
                                        <MenuItem value="AB+">AB+</MenuItem>
                                        <MenuItem value="AB-">AB-</MenuItem>
                                        <MenuItem value="O+">O+</MenuItem>
                                        <MenuItem value="O-">O-</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>


                        </Grid>
                        {isHealthEdit &&
                            <div className='mt-3 d-flex justify-content-end'>
                                <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleHealthInfoSave}>Save</Button>
                            </div>
                        }
                    </div>
                </Box>
            </Modal>

            <Modal open={openModalSkills} onClose={() => { setOpenModalSkills(false); }}>
                <Box sx={{ width: "auto", borderRadius: 2, minWidth: "80%", maxHeight: "80%" }} className='modal-box-1'>
                    <div className="px-3 pt-3">
                        <div className="soc-modal-heading" style={{ position: "relative" }}>
                            <h5>Add Hobbies and Interests</h5>
                            <span className='span-center-align file-attach-icon-container'>
                                <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => { setOpenModalSkills(false) }}>
                                    <CloseRoundedIcon />
                                </IconButton></span>
                        </div>
                    </div>
                    <Divider className='my-2' sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />
                    <div className="px-3 mb-3" style={{ maxHeight: 'calc(80vh - 150px)' }}>
                        {hobbiesSections.map((item, index) => (
                            <section className='soc-modal-section pb-3' key={index} >
                                <div className='mb-3 profile-modal-heading1'>{item?.title}</div>
                                {item?.skills.map((skill, linkIndex) => (
                                    <SkillItemForLightBox key={skill} label={skill} selectedSkills={personalHobbies} onAdd={handleAddSkill} />
                                ))}
                            </section>
                        ))}
                    </div>
                </Box>
            </Modal>

            <Modal open={openModalLanguage} onClose={() => { setOpenLanguage(false) }}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'white', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, minWidth: "80%", maxHeight: "80%", overflowY: "scroll" }}>
                    <div className="px-3 pt-3">
                        <div className="soc-modal-heading" style={{ position: "relative" }}>
                            <h5>Add Languages</h5>
                            <span>Select the Languages</span>
                            <span className='span-center-align file-attach-icon-container'>
                                <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => { setOpenLanguage(false) }}>
                                    <CloseRoundedIcon />
                                </IconButton></span>
                        </div>
                    </div>
                    <Divider className='my-2' sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} />
                    <div className="p-3 mb-3" style={{ maxHeight: 'calc(80vh - 150px)' }}>
                        <section className='soc-modal-section pb-3'>
                            {DefaultLanguages.map((language, index) => (
                                <SkillItemForLightBox key={index} label={language} selectedSkills={personalProfileLanguages} onAdd={handleAddLanguage} />
                            ))}
                        </section>
                    </div>
                </Box>
            </Modal>

            <Modal open={isFamilyEdit} onClose={() => { setisFamilyEdit(false); setEditMember(null) }}>
                <Box sx={{ width: "50%", maxWidth: "80%", maxHeight: "80%", p: 3 }} className='modal-box-1'>
                    <div className="soc-modal-heading mb-3" style={{ position: "relative" }}>
                        <strong>Edit Family Information</strong>
                        <span className='span-center-align file-attach-icon-container'>
                            <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => { setisFamilyEdit(false); setEditMember(null) }}>
                                <CloseRoundedIcon />
                            </IconButton></span>
                    </div>
                    <div className="my-2 user-details-container">
                        <FamilyMemberInfo
                            member={memberKey?.member === "kids" ? familyEditState.kids[memberKey.index] : familyEditState[memberKey.member]}
                            index={memberKey?.member === "kids" ? memberKey.index : null}
                            handleChange={memberKey?.member === "kids" ? handleKidChange : handleFamilyEditChange}
                            handlePhoneChange={handleTelInputChange}
                            isEditMode={isFamilyEdit}
                            memberType={memberKey?.memberType}
                            onVerify={memberKey?.member !== "kids" ? handleVerifyMember : undefined}
                        />
                    </div>
                    {isFamilyEdit && (
                        <div className='mt-3 d-flex justify-content-end'>
                            <Button id="familyInfoSaveButton" variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleFamilyInfoSave1}>Save</Button>
                        </div>
                    )}
                </Box>
            </Modal>

            <Modal open={openAddKidModal} onClose={() => setOpenAddKidModal(false)}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'white', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, p: 3, maxHeight: "80%" }}>
                    <div className="modal-heading">
                        <h5>Add Another Kid</h5>
                        <span>Update the new family member details.</span>
                        <span className='span-center-align file-attach-icon-container'>
                            <IconButton color="rgb(0, 0, 0, 0.54)" onClick={() => setOpenAddKidModal(false)}>
                                <CloseRoundedIcon />
                            </IconButton></span>
                    </div>
                    <Grid container spacing={2} sx={{ paddingTop: '1.5rem' }}>
                        <Grid item xs={6}>
                            <Grid container direction='column' spacing={2}>
                                <Grid item>
                                    <TextField
                                        label="First Name"
                                        value={newKid?.fName}
                                        fullWidth
                                        onChange={handleNewKidChange('fName')}
                                        required
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        label="Date of Birth"
                                        type="date"
                                        value={newKid?.dob}
                                        fullWidth
                                        onChange={handleNewKidChange('dob')}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            max: today
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container direction="column" spacing={2}>
                                <Grid item>
                                    <TextField
                                        label="Last Name"
                                        value={newKid?.lName}
                                        fullWidth
                                        onChange={handleNewKidChange('lName')}
                                        required
                                    />
                                </Grid>
                                <Grid item>
                                    <TextField
                                        name="kidBloodGroup"
                                        label="Blood Group"
                                        select
                                        value={newKid?.blood}
                                        fullWidth
                                        onChange={handleNewKidChange('blood')}
                                    >
                                        <MenuItem value=""><i>Select</i></MenuItem>
                                        <MenuItem value="A+">A+</MenuItem>
                                        <MenuItem value="A-">A-</MenuItem>
                                        <MenuItem value="B+">B+</MenuItem>
                                        <MenuItem value="B-">B-</MenuItem>
                                        <MenuItem value="AB+">AB+</MenuItem>
                                        <MenuItem value="AB-">AB-</MenuItem>
                                        <MenuItem value="O+">O+</MenuItem>
                                        <MenuItem value="O-">O-</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <div className="d-flex justify-content-end">
                        <Button
                            onClick={addNewKid}
                            variant="contained"
                            disabled={!newKid?.fName || !newKid?.lName}
                            sx={{ backgroundColor: "#0044C6" }}
                            className="mt-3"
                        >
                            Save
                        </Button>
                    </div>
                </Box>
            </Modal>

            <Modal open={openFamilyVerify} onClose={() => { setOpenFamilyVerify(false); setisFamilyEdit(true) }}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", minWidth: "40%", bgcolor: 'white', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, p: 3, maxHeight: "80%", overflowY: 'auto' }}>
                    {(isPhoneVerified && isEmailVerified) ? (
                        <div className="flex-center flex-column">
                            <img
                                src={VerifySuccess}
                                alt="Successfully Verified"
                                className="dialogImage"
                            />
                            <div className="profile-modal-heading1 mb-2">Email ID and Phone Number Verified</div>
                            <div className="time-label">Your family details have been successfully verified.</div>
                            <Button className="mt-3" variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={() => { setOpenFamilyVerify(false); setisFamilyEdit(true) }} disableTouchRipple>Continue</Button>
                        </div>
                    ) : (
                        <div>
                            <div className="modal-heading">
                                <div className="profile-modal-heading1">Verify Family Member</div>
                                {/* {console.log("Added data", member)} */}
                                <span className='span-center-align file-attach-icon-container'>
                                    <IconButton color="rgb(0, 0, 0, 0.54)" disableTouchRipple onClick={() => setOpenFamilyVerify(false)}>
                                        <CloseRoundedIcon />
                                    </IconButton></span>
                            </div>
                            <div className="modal-body">
                                {!isEmailVerified ? <>
                                    <div className="py-4">
                                        {/* <TextField
                                                                        fullWidth
                                                                        value={emailOtp}
                                                                        onChange={(e) => setEmailOtp(e.target.value)}
                                                                        label="Enter Email OTP"
                                                                        autoFocus
                                                                        autoComplete={false}
                                                                        autoCorrect={false}
                                                                        disabled={isEmailVerified}
                                                                        error={!!emailError}
                                                                        helperText={emailError || ' '}
                                                                    /> */}
                                        <TextField
                                            fullWidth
                                            value={emailOtp}
                                            onChange={(e) => setEmailOtp(e.target.value)}
                                            label="Enter Email OTP"
                                            autoFocus
                                            autoComplete="off"
                                            autoCorrect="off"
                                            disabled={isEmailVerified}
                                            error={!!emailError} // Convert emailError to boolean
                                            helperText={emailError || ' '} // Show error message or a blank space
                                        />
                                        <div className="mt-12px">
                                            <span className="helper-text-style">Remaining Time: 00.{emailOtpSeconds < 10 ? `0${emailOtpSeconds}` : emailOtpSeconds}s</span>
                                        </div>

                                        <div className="d-flex justify-content-between mt-4">
                                            <span className="span-center-align">
                                                <span className="helper-text-style me-2">Didn't receive the mail?</span>
                                                <Button sx={{ color: '#0044C6' }} disabled={emailOtpSeconds > 0} onClick={() => sendEmailOtp(currentMember.email)}
>Resend</Button>
                                            </span>
                                            <Button variant="contained" sx={{ backgroundColor: '#0044C6' }}
                                                disabled={isEmailVerified}
                                                onClick={() => verifyEmailOtp(currentMember?.email)}
                                                className={`verify-button ${isEmailVerified ? 'success-green' : ''}`}
                                                disableTouchRipple >
                                                {isEmailVerified ? 'Verified' : 'Verify'}
                                            </Button>
                                        </div>
                                    </div>

                                    <Divider sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }} /></> : ""}


                                <div className="pt-4">

                                    {/* <TextField
                                        fullWidth
                                        value={phoneOtp}
                                        onChange={(e) => setPhoneOtp(e.target.value)}
                                        label="Enter Phone OTP"
                                        autoFocus
                                        autoComplete={false}
                                        autoCorrect={false}
                                        disabled={!isEmailVerified}
                                        error={phoneError}
                                        helperText={phoneError || ' '}
                                    /> */}

                                    <TextField
                                        fullWidth
                                        value={phoneOtp}
                                        onChange={(e) => setPhoneOtp(e.target.value)}
                                        label="Enter Phone OTP"
                                        // autoFocus
                                        autoComplete="off"
                                        autoCorrect="off"
                                        disabled={isPhoneVerified}
                                        error={!!phoneError} // Convert emailError to boolean
                                        helperText={phoneError || ' '} // Show error message or a blank space
                                    />
                                    <div className="mt-12px">
                                        <span className="helper-text-style">Remaining Time: 00.{phoneOtpSeconds < 10 ? `0${phoneOtpSeconds}` : phoneOtpSeconds}s</span>
                                    </div>

                                    <div className="d-flex justify-content-between mt-4">
                                        <span className="span-center-align">
                                            <span className="helper-text-style me-2">Didn't receive the SMS?</span>
                                            <Button sx={{ color: '#0044C6' }} disabled={phoneOtpSeconds > 0} onClick={() => sendPhoneOtp(currentMember.phoneNo)}>Resend</Button>
                                        </span>
                                        <Button variant="contained" sx={{ backgroundColor: '#0044C6' }}
                                            disabled={!isEmailVerified}
                                            onClick={() => verifyPhoneOtp(currentMember.phoneNo)}
                                            className={`verify-button ${isPhoneVerified ? 'success-green' : ''}`}
                                            disableTouchRipple >
                                            {isPhoneVerified ? 'Verified' : 'Verify'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>)}

                </Box>
            </Modal >

            {openHealthAlert &&
                <AlertDialog
                    open={openHealthAlert}
                    onClose={handleCloseHealthAlert}
                    dialogTitle={healthAlertConfig?.title}
                    dialogMessage={healthAlertConfig?.message}
                    continueFn={healthAlertConfig?.continueFn}
                    continueLabel={healthAlertConfig?.continueLabel}
                />
            }

            <AlertDialog
                open={openFamilyAlert}
                onClose={handleCloseFamilyAlert}
                dialogTitle={familyAlertConfig?.title}
                dialogMessage={familyAlertConfig?.message}
                continueFn={familyAlertConfig?.continueFn}
                continueLabel={familyAlertConfig?.continueLabel}
            />



            <CircleCropper open={openCropper} onClose={handleCropClose} onSave={handleSaveCroppedImage} file={selectedFile} selectedImage={selectedImage} aspectRatio={1} minDimension={100} />

            <RectangleCropper open={openRectCropper} onClose={handleRectCropperClose} onSave={handleSaveBgImage} file={selectedBgFile} selectedImage={selectedBgImage} />

            <ViewConnections open={connectionViewModal} onClose={() => setConnectionViewModal(false)} connectionCount={Personaldata?.connection_count || 0} connectionList={connectionList} setConnectionList={setConnectionList} />

            <ShareProfile
                open={openShareProfile}
                onClose={() => setOpenShareProfile(false)}
                qrCodeUrl={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`}
                profileType='Personal Profile'
                handleSuccess={handleSuccess}
                handleFailure={handleFailure} />

            <InviteProfile open={openInviteProfile} setModalOpen={setOpenInviteProfile} handleSuccess={handleSuccess} handleFailure={handleFailure} />

            <ToastContainer position="bottom-left" toastClassName="email-toast-success" />
        </>
    )
}

const SkillBox = styled(Box)({
    border: "1px solid #D9D9D9",
    height: '32px',
    borderRadius: '16px',
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 12px",
    margin: '6px 6px 6px 0px',
    gap: '5px',
    fontSize: '14px',
    lineHeight: '20.02px'
});

function SkillItem({ label, isEdit, onAdd }) {

    return (
        <SkillBox>
            <div className="skill-item">{label}</div>
            {isEdit && (
                <IconButton
                    color='color-lightred'
                    onClick={() => onAdd(label)}
                    className='flex-center delete-icon-skills'
                >
                    <CancelIcon color="color-lightred" className="delete-icon-skills" />
                </IconButton>
            )}
        </SkillBox>
    );
}

function SkillItemForNewAddItem({ selectedSkills, onAdd, label }) {
    const [inputValue, setInputValue] = useState('');

    return (
        <SkillBox>
            <TextField
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder={label}
                variant='outlined'
                size='small'
                className="ms-2 textfield-new-styles text-center"
                sx={{
                    fontSize: '14px', lineHeight: '20.02px',
                    '& .MuiOutlinedInput-input': {
                        paddingLeft: 0
                    }
                }}
            />
            <IconButton
                color='#0044C6'
                onClick={() => {
                    onAdd(inputValue);
                    setInputValue('');
                }}
                className='flex-center'
                sx={{ p: 0 }}
            >
                <AddCircleRoundedIcon />
            </IconButton>
        </SkillBox>
    );
}

function SkillItemForLightBox({ label, selectedSkills, onAdd }) {
    const isSkillSelected = selectedSkills.includes(label);


    return (
        <SkillBox>
            <div>{label}</div>
            <IconButton
                color='#0044C6'
                onClick={() => onAdd(label)}
                className='flex-center'
                sx={{ p: 0 }}
                disableTouchRipple
            >
                {isSkillSelected ? <CancelIcon className="delete-icon-skills" onClick={() => onAdd(label)} /> : <AddCircleRoundedIcon />}
            </IconButton>
        </SkillBox>
    );
}

const FamilyMemberInfo = ({ member, isEditMode, handleChange, handlePhoneChange, memberType, index, onVerify }) => {
    const reference = memberType === 'Kid' ? index : memberType.toLowerCase();

    const bloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

    const today = new Date().toISOString().split('T')[0];

    const isAdultMember = memberType !== 'Kid' ? true : false;

    const isFieldEmpty = (field) => !field || field.trim?.().length === 0;
    const areFieldsFilled = member &&
        ((isAdultMember ? (!isFieldEmpty(member?.phoneNo) || !isFieldEmpty(member?.email)) : true)) &&
        !isFieldEmpty(member?.fName) &&
        !isFieldEmpty(member?.lName);

    // const currentMember = isEditMode ? member : contextMember;
    let isMemberVerified = member?.isVerified;

    const getValue = (field) => {
        return member?.[field];
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return new Intl.DateTimeFormat(navigator.language, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).format(date);
    };

    const anyFieldFilled = getValue('fName') || getValue('lName') || getValue('dob') || getValue('blood') || (isAdultMember && (getValue('email') || getValue('phoneNo')));

    const handleEmailChange = (event) => {
        handleChange(reference, 'email')(event);
        setErrors((prevState) => ({
            ...prevState,
            email: false,
        }));
    }

    const handlePhoneNumberChange = (value) => {
        handlePhoneChange(reference, 'phoneNo')(value); // Pass the new value
        setErrors((prevState) => ({
            ...prevState,
            phoneNo: false, // Clear the error
        }));
    }

    const [errors, setErrors] = useState({
        email: false,
        phoneNo: false
    })
    const emailTooltip = "If empty, OTP will be sent to your registered E-mail ID for verification";

    const verifyMemberFunction = () => {
        let isEmailValid = true;
        let isPhoneValid = true;

        // Email validation (if provided)
        if (getValue('email')) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            isEmailValid = emailRegex.test(getValue('email').trim());

            if (!isEmailValid) {
                setErrors((prevState) => ({
                    ...prevState,
                    email: true,  // Show email error if invalid
                }));
            }
        } else {
            isEmailValid = true; // Email can be empty
        }

        // Phone number validation (mandatory)
        if (getValue('phoneNo')) {
            isPhoneValid = matchIsValidTel(getValue('phoneNo'));
            if (!isPhoneValid) {
                setErrors((prevState) => ({
                    ...prevState,
                    phoneNo: true,  // Show phone error if invalid
                }));
            }
        } else {
            setErrors((prevState) => ({
                ...prevState,
                phoneNo: true,  // Show phone error if invalid
            }));
        }

        // If both are valid, proceed with verification
        if (isPhoneValid && (isEmailValid || !getValue('email'))) {
            onVerify(memberType, member);
        }
    };

    // (() => {
    //     if (isEditMode) {
    //         console.log("FAMILY MEMBER ======", member);
    //     }
    // })()

    return (
        <div className="user-details-container">
            {isEditMode ? (
                <Grid container spacing={2}>
                    {/* Edit Mode - Form Fields */}
                    <Grid item xs={6}>
                        <TextField
                            label="First Name"
                            value={getValue('fName')}
                            fullWidth
                            onChange={handleChange(reference, 'fName')}
                            required pattern="^[A-Za-z]+$"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Last Name"
                            value={getValue('lName')}
                            fullWidth
                            onChange={handleChange(reference, 'lName')}
                            required pattern="^[A-Za-z]+$"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Date of Birth"
                            type="date"
                            value={getValue('dob')}
                            onChange={handleChange(reference, 'dob')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                max: today,
                            }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <TextField
                                label="Blood Group"
                                select
                                value={getValue('blood')}
                                onChange={handleChange(reference, 'blood')}
                            >
                                <MenuItem value="" key="Select"><i>Select</i></MenuItem>
                                {bloodGroups?.map((bloodGroup, index) => (
                                    <MenuItem value={bloodGroup} key={index}>{bloodGroup}</MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                    </Grid>

                    {isAdultMember && (
                        <>
                            <Grid item xs={6}>
                                <Tooltip
                                    title={(getValue('email') === "" && isEditMode) ? emailTooltip : ''}
                                    placement="bottom"
                                    arrow
                                    PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, -30] } }] }}
                                >
                                    <TextField
                                        label={`${memberType}'s Email ID`}
                                        value={getValue('email')}
                                        onChange={handleEmailChange}
                                        fullWidth
                                        error={errors.email}
                                        helperText={errors.email ? 'Invalid E-mail ID' : ' '}
                                        InputProps={{
                                            endAdornment: (
                                                getValue('email') && (
                                                    <InputAdornment position="end">
                                                        <VerifiedTick className={isMemberVerified ? 'green-verified-tick' : ''} />
                                                    </InputAdornment>
                                                )
                                            ),
                                        }}
                                    />
                                </Tooltip>
                            </Grid>

                            <Grid item xs={6}>
                                <MuiTelInput
                                    label={`${memberType}'s Phone Number`}
                                    value={getValue('phoneNo')}
                                    onChange={handlePhoneNumberChange}
                                    defaultCountry="IN"
                                    MenuProps={PhoneInputMenuProps}
                                    required
                                    fullWidth
                                    error={errors.phoneNo}
                                    helperText={errors.phoneNo ? 'Invalid or Empty Phone Number' : " "}
                                    InputProps={{
                                        endAdornment: getValue('phoneNo') && (
                                            <InputAdornment position="end">
                                                <VerifiedTick className={isMemberVerified ? 'green-verified-tick' : ''} />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            ) : (
                <div className="family-block-contents">
                    {/* View Mode - Display Data in Single Column */}
                    {anyFieldFilled ? (<>
                        {getValue('fName') && (
                            <div className="family-data-item">
                                <div className="family-title">Name</div>
                                <div>{getValue('fName')} {getValue('lName')}</div>
                            </div>
                        )}
                        {getValue('dob') && (
                            <div className="family-data-item">
                                <div className="family-title">Date of Birth</div>
                                <div>{formatDate(getValue('dob'))}</div>
                            </div>
                        )}
                        {getValue('blood') && (
                            <div className="family-data-item">
                                <div className="family-title">Blood Group</div>
                                <div>{getValue('blood')}</div>
                            </div>
                        )}
                        {isAdultMember && (
                            <>
                                {getValue('email') && (
                                    <div className="family-data-item">
                                        <div className="family-title">Email-ID</div>
                                        <div>{getValue('email')}</div>
                                    </div>
                                )}
                                {getValue('phoneNo') && (
                                    <div className="family-data-item">
                                        <div className="family-title">Phone Number</div>
                                        <div>{getValue('phoneNo')}</div>
                                    </div>
                                )}
                            </>
                        )}
                    </>) : (
                        <div className="family-data-item">
                            <div className="family-title">No Details Added!</div>
                            <div>Click on Edit to add your family member's details!</div>
                        </div>
                    )}
                </div>

            )}


            {isAdultMember && isEditMode && (
                <Grid item xs={12} className="pt-2">
                    <div className="d-flex justify-content-between gap-3">
                        <span className="helper-text-style">
                            Email ID and Phone Number are optional fields.<br />
                            Verify them both to enhance financial benefits and PPF score.
                            <span className="text-danger helper-text-style"><br />If Empty,<br /> OTP directly sent to the registered E-mail id.</span>
                        </span>

                        {isMemberVerified ? (
                            <Button variant="contained" className="verify-button success-green" sx={{ height: "48px" }} disabled>
                                Verified
                            </Button>
                        ) : (
                            <Button variant="contained" sx={{ backgroundColor: '#0044C6', height: "48px" }} disabled={!areFieldsFilled} onClick={verifyMemberFunction} disableTouchRipple>
                                Verify
                            </Button>
                        )}
                    </div>
                </Grid>
            )}
        </div>
    );
};

const getOrdinalString = (index) => {
    const ordinals = ["First", "Second", "Third", "Fourth", "Fifth", "Sixth", "Seventh", "Eighth", "Ninth", "Tenth", "Eleventh", "Twelfth", "Thirteenth", "Fourteenth", "Fifteenth"];
    return ordinals[index] || `${index + 1}th`;
};

export default PersonalProfile